/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/components/app/app.component.tsx":
/*!**********************************************!*\
  !*** ./src/components/app/app.component.tsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.App = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const launcher_component_1 = __webpack_require__(/*! ../launcher/launcher.component */ "./src/components/launcher/launcher.component.tsx");
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const chrome_component_1 = __webpack_require__(/*! ../chrome/chrome.component */ "./src/components/chrome/chrome.component.tsx");
const App = ({ chatScopes, webChatConfig, sourceInfo, tpcCheck, knownUris, providers, adaptiveCardHostConfig, middleware, themes, localizeConfig, view, actions, onAPIReady }) => {
    return (react_1.default.createElement(recoil_1.RecoilRoot, null,
        react_1.default.createElement(context_1.CoreContext, Object.assign({}, {
            actions,
            chatScopes,
            knownUris,
            providers,
            sourceInfo,
            view,
            themes,
            localizeConfig,
            onAPIReady,
            tpcCheck,
            middleware
        }),
            react_1.default.createElement(launcher_component_1.Launcher, Object.assign({}, {
                adaptiveCardHostConfig,
                webChatConfig
            }),
                react_1.default.createElement(chrome_component_1.Chrome, null)))));
};
exports.App = App;


/***/ }),

/***/ "./src/components/app/index.ts":
/*!*************************************!*\
  !*** ./src/components/app/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./app.component */ "./src/components/app/app.component.tsx"), exports);


/***/ }),

/***/ "./src/components/chat-root/chat-root.component.tsx":
/*!**********************************************************!*\
  !*** ./src/components/chat-root/chat-root.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatRoot = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const { Composer } = botframework_webchat_1.Components;
const ChatRoot = ({ children }) => {
    var _a;
    const hostConfig = smarthub_common_1.useHostConfig();
    const webChatConfig = smarthub_common_1.useChatConfig();
    const [context, setContext] = react_1.useState(null);
    const { directline, config } = (_a = smarthub_common_1.useDirectline()) !== null && _a !== void 0 ? _a : {};
    const webChatStrings = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.webchat);
    react_1.useEffect(() => {
        if (directline) {
            const store = botframework_webchat_1.createStore({});
            setContext({
                store,
                directline
            });
        }
    }, [directline]);
    const activityMiddleware = smarthub_common_1.useActivityMiddleware(context);
    const attachmentMiddleware = smarthub_common_1.useAttachmentMiddleware(context);
    const actionMiddleware = smarthub_common_1.useActionMiddleware(context);
    const { bot: { user: { id: userId } } } = config || { bot: { user: {} } };
    return (react_1.default.createElement(react_1.default.Fragment, null, (context === null || context === void 0 ? void 0 : context.directline) && react_1.default.createElement(Composer, Object.assign({ activityMiddleware: activityMiddleware, attachmentMiddleware: attachmentMiddleware, cardActionMiddleware: actionMiddleware, adaptiveCardsHostConfig: hostConfig, userID: userId, directLine: context.directline, store: context.store, overrideLocalizedStrings: webChatStrings }, webChatConfig), children)));
};
exports.ChatRoot = ChatRoot;


/***/ }),

/***/ "./src/components/chat-root/index.ts":
/*!*******************************************!*\
  !*** ./src/components/chat-root/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-root.component */ "./src/components/chat-root/chat-root.component.tsx"), exports);


/***/ }),

/***/ "./src/components/chrome/chrome.component.tsx":
/*!****************************************************!*\
  !*** ./src/components/chrome/chrome.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Chrome = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const main_menu_1 = __webpack_require__(/*! ../main-menu */ "./src/components/main-menu/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const panel_1 = __webpack_require__(/*! ../panel */ "./src/components/panel/index.ts");
const skip_links_1 = __webpack_require__(/*! ../skip-links */ "./src/components/skip-links/index.ts");
const maxZ = 1000000;
const useStyles = react_jss_1.createUseStyles({
    chrome: ({ position, mode }) => ({
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 0,
        zIndex: maxZ,
        flexDirection: "row",
        "& > :first-child": {
            marginLeft: mode == "chat" && position == "right" ? "auto" : undefined,
        },
        "& > :last-child": {
            order: position == "right" ? 3 : 1,
        },
    }),
    panels: ({ mode }) => ({
        order: 2,
        flex: "1 1",
        width: "100%",
        height: "100vh",
        display: "flex",
        position: "relative",
        overflow: "hidden",
        "&:empty": mode == "chat"
            ? {
                width: 0,
                flex: "0 0",
            }
            : undefined,
    }),
});
const notificationTemplateID = "component.notification";
const Chrome = () => {
    const { position } = smarthub_common_1.usePanelView("chat");
    const { mode } = smarthub_common_1.useViewConfig();
    const styleConfig = react_1.useMemo(() => ({
        mode,
        position,
    }), [mode, position]);
    const render = smarthub_common_1.useRender();
    const styles = useStyles(styleConfig);
    const { rootLabelChat, rootLabelFull } = smarthub_common_1.useLocalizeConfig();
    const role = mode == "chat" ? "dialog" : undefined;
    const label = mode == "chat" ? rootLabelChat : rootLabelFull;
    return react_1.useMemo(() => (react_1.default.createElement(react_1.default.Fragment, null,
        mode == "full" && react_1.default.createElement(skip_links_1.SkipLinks, null),
        react_1.default.createElement(context_1.BreakpointProvider, { className: styles.chrome, role: role, "aria-label": label },
            react_1.default.createElement(main_menu_1.MainMenu, null),
            mode !== "chat" && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(context_1.BreakpointProvider, { className: styles.panels },
                    react_1.default.createElement(panel_1.Panel, { type: "main" }),
                    react_1.default.createElement(panel_1.Panel, { type: "page" })))),
            react_1.default.createElement(panel_1.Panel, { type: "chat" })),
        render(notificationTemplateID)())), [styles]);
};
exports.Chrome = Chrome;


/***/ }),

/***/ "./src/components/chrome/index.ts":
/*!****************************************!*\
  !*** ./src/components/chrome/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chrome.component */ "./src/components/chrome/chrome.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/api-provider/api-provider.component.tsx":
/*!************************************************************************!*\
  !*** ./src/components/context/api-provider/api-provider.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.APIProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const APIProvider = ({ onAPIReady, children }) => {
    const extendedAPIRef = react_1.useRef(null);
    const setExtendedAPI = react_1.useCallback((api) => extendedAPIRef.current = api, []);
    const openPromiseRef = react_1.useRef(null);
    const [chromeState, setChromeState] = smarthub_common_1.useChromeState();
    const [getChromeState, onChromeStateChange] = smarthub_common_1.useEventDispatch(chromeState, (state, previous) => {
        if (state == 'closed' && previous == 'open') {
            openPromiseRef.current = null;
            setBotReady(false);
            setExtendedAPI(null);
        }
    });
    const [botReady, setBotReady] = react_1.useState();
    const [getBotReady, onBotReadyChange] = smarthub_common_1.useEventDispatch(botReady, (ready) => {
        if (ready && openPromiseRef.current) {
            openPromiseRef.current.resolve(ready);
            openPromiseRef.current = null;
        }
    });
    const [context, setContext] = react_1.useState({
        botReady,
        setBotReady,
        setExtendedAPI
    });
    const command = react_1.useCallback((action) => {
        if (extendedAPIRef.current)
            return extendedAPIRef.current.command(action);
        return Promise.reject(new Error("The bot is not available. Use open and wait for bot to become ready."));
    }, []);
    const open = react_1.useCallback((options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { action } = options || {};
        if (openPromiseRef.current)
            throw new Error("Wait for webchat to open");
        let promise = new Promise((resolve, reject) => {
            openPromiseRef.current = { resolve, reject };
        });
        setChromeState('open');
        const success = yield promise;
        return action && success
            ? yield command(action)
            : success;
    }), []);
    const close = react_1.useCallback(() => {
        setChromeState('closed');
    }, []);
    const apiRef = react_1.useRef({
        open,
        close,
        chromeState: getChromeState,
        botReady: getBotReady,
        onChromeStateChange,
        onBotReadyChange,
        command
    });
    react_1.useEffect(() => {
        setContext({
            botReady,
            setBotReady,
            setExtendedAPI
        });
    }, [botReady]);
    react_1.useEffect(() => {
        if (onAPIReady)
            onAPIReady(apiRef.current);
    }, []);
    return react_1.default.createElement(smarthub_common_1.APIContext.Provider, { value: context }, children);
};
exports.APIProvider = APIProvider;


/***/ }),

/***/ "./src/components/context/api-provider/index.ts":
/*!******************************************************!*\
  !*** ./src/components/context/api-provider/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./api-provider.component */ "./src/components/context/api-provider/api-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/app-provider/app-provider.component.tsx":
/*!************************************************************************!*\
  !*** ./src/components/context/app-provider/app-provider.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AppProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const AppProvider = ({ children, chatScopes = [], providers, sourceInfo, knownUris, actions = [], view }) => {
    const focusCallback = react_1.useRef({});
    const lastActions = react_1.useRef([]);
    const safeProviders = Object.assign({ auth: [], cogsvc: [], content: [], file: [], format: [], notifications: [], preferences: {
            permanent: null,
            temporary: null,
        }, profile: [], route: [] }, providers);
    const focus = react_1.useCallback((name) => {
        const callback = focusCallback.current[name];
        callback && callback();
    }, []);
    const registerFocus = react_1.useCallback((name, callback) => {
        focusCallback.current[name] = callback;
    }, []);
    const registerLastAction = react_1.useCallback((panelType, callback) => {
        const currentDate = new Date();
        const time = currentDate.getTime();
        const currentRegisterAction = { panelType, time, callback };
        if (lastActions.current.filter(e => e.panelType === panelType).length > 0) {
            const panelIndex = lastActions.current.findIndex((obj => obj.panelType == panelType));
            lastActions.current[panelIndex] = currentRegisterAction;
        }
        else {
            lastActions.current[lastActions.current.length] = currentRegisterAction;
        }
        lastActions.current.sort((a, b) => b.time - a.time);
    }, []);
    const focusLastAction = react_1.useCallback((panelType) => {
        let lastActionIs;
        if (panelType === 'main')
            panelType = 'chat';
        const removeIndex = lastActions.current.findIndex(item => (item === null || item === void 0 ? void 0 : item.panelType) === panelType);
        removeIndex != -1 && lastActions.current.splice(removeIndex, 1);
        if (lastActions.current.length == 0) {
            focus('mainContent');
            return false;
        }
        else {
            lastActionIs = lastActions.current[lastActions.current.length - 1];
            try {
                (lastActionIs === null || lastActionIs === void 0 ? void 0 : lastActionIs.callback) && (lastActionIs === null || lastActionIs === void 0 ? void 0 : lastActionIs.callback());
                return true;
            }
            catch (error) {
                /* eslint-disable */ console.log(...oo_oo(`39e254c4_0`, "error occured in the callback function"));
                focus('mainContent');
                return false;
            }
        }
    }, []);
    const [chromeState, setChromeState] = react_1.useState(view.mode == 'chat'
        ? 'closed'
        : 'open');
    const [context, setContext] = react_1.useState({
        chatScopes,
        providers: safeProviders,
        sourceInfo,
        knownUris,
        actions,
        view,
        chromeState,
        setChromeState,
        focus,
        registerFocus,
        registerLastAction,
        focusLastAction
    });
    react_1.useEffect(() => {
        setContext({
            chatScopes,
            providers: safeProviders,
            sourceInfo,
            knownUris,
            actions,
            view,
            chromeState,
            setChromeState,
            focus,
            registerFocus,
            registerLastAction,
            focusLastAction
        });
    }, [chatScopes, providers, sourceInfo, knownUris, actions, view, chromeState, setChromeState, focus, registerFocus, registerLastAction]);
    return react_1.default.createElement(smarthub_common_1.AppContext.Provider, { value: context }, children);
};
exports.AppProvider = AppProvider;
function oo_cm() { try {
    return (0, eval)("/* https://github.com/wallabyjs/console-ninja#how-does-it-work */'use strict';function _0x35a9(_0x2500f6,_0xce92d){var _0x421f49=_0x421f();return _0x35a9=function(_0x35a963,_0x3ce0d0){_0x35a963=_0x35a963-0x1a9;var _0x5a2f24=_0x421f49[_0x35a963];return _0x5a2f24;},_0x35a9(_0x2500f6,_0xce92d);}var _0x550420=_0x35a9;(function(_0x4c3eff,_0x4d9708){var _0x174bb7=_0x35a9,_0x5822f1=_0x4c3eff();while(!![]){try{var _0x869cae=parseInt(_0x174bb7(0x1ae))/0x1+parseInt(_0x174bb7(0x23a))/0x2+-parseInt(_0x174bb7(0x1b9))/0x3+parseInt(_0x174bb7(0x1fb))/0x4+parseInt(_0x174bb7(0x23b))/0x5+parseInt(_0x174bb7(0x1d1))/0x6+-parseInt(_0x174bb7(0x244))/0x7;if(_0x869cae===_0x4d9708)break;else _0x5822f1['push'](_0x5822f1['shift']());}catch(_0x5a0a1b){_0x5822f1['push'](_0x5822f1['shift']());}}}(_0x421f,0xa7d1c));var he=Object[_0x550420(0x213)],te=Object['defineProperty'],ce=Object['getOwnPropertyDescriptor'],fe=Object[_0x550420(0x207)],le=Object[_0x550420(0x1cd)],_e=Object[_0x550420(0x254)][_0x550420(0x1f8)],pe=(_0x5b9379,_0x5a4f69,_0x3c4adc,_0x193958)=>{var _0xb12e51=_0x550420;if(_0x5a4f69&&typeof _0x5a4f69=='object'||typeof _0x5a4f69==_0xb12e51(0x204)){for(let _0x332c01 of fe(_0x5a4f69))!_e[_0xb12e51(0x269)](_0x5b9379,_0x332c01)&&_0x332c01!==_0x3c4adc&&te(_0x5b9379,_0x332c01,{'get':()=>_0x5a4f69[_0x332c01],'enumerable':!(_0x193958=ce(_0x5a4f69,_0x332c01))||_0x193958[_0xb12e51(0x202)]});}return _0x5b9379;},ne=(_0x254cab,_0x5cd1c3,_0x4f12ed)=>(_0x4f12ed=_0x254cab!=null?he(le(_0x254cab)):{},pe(_0x5cd1c3||!_0x254cab||!_0x254cab[_0x550420(0x1e7)]?te(_0x4f12ed,_0x550420(0x210),{'value':_0x254cab,'enumerable':!0x0}):_0x4f12ed,_0x254cab)),V=class{constructor(_0x1c3ac9,_0x23d72f,_0x28c8bf,_0x5b5e28){var _0x8b2cb2=_0x550420;this[_0x8b2cb2(0x263)]=_0x1c3ac9,this[_0x8b2cb2(0x1e0)]=_0x23d72f,this[_0x8b2cb2(0x1e8)]=_0x28c8bf,this['nodeModules']=_0x5b5e28,this[_0x8b2cb2(0x239)]=!0x0,this['_allowedToConnectOnSend']=!0x0,this[_0x8b2cb2(0x1f5)]=!0x1,this['_connecting']=!0x1,this[_0x8b2cb2(0x268)]=!!this[_0x8b2cb2(0x263)]['WebSocket'],this[_0x8b2cb2(0x24d)]=null,this[_0x8b2cb2(0x24b)]=this['_inBrowser']?_0x8b2cb2(0x255):'failed\\x20to\\x20send\\x20logs,\\x20restarting\\x20the\\x20process\\x20may\\x20help';}async['getWebSocketClass'](){var _0x429c62=_0x550420;if(this[_0x429c62(0x24d)])return this[_0x429c62(0x24d)];let _0x17a820;if(this['_inBrowser'])_0x17a820=this[_0x429c62(0x263)]['WebSocket'];else try{_0x17a820=require(require('path')[_0x429c62(0x228)](this['nodeModules'],'ws'));}catch{try{let _0x5ea89c=await import('path');_0x17a820=(await import((await import(_0x429c62(0x1db)))[_0x429c62(0x23e)](_0x5ea89c[_0x429c62(0x228)](this[_0x429c62(0x1b8)],'ws/index.js'))[_0x429c62(0x1ee)]()))[_0x429c62(0x210)];}catch{throw new Error(_0x429c62(0x1c1));}}return this['_WebSocketClass']=_0x17a820,_0x17a820;}[_0x550420(0x241)](){var _0x284a26=_0x550420;this[_0x284a26(0x1f1)]||this[_0x284a26(0x1f5)]||(this[_0x284a26(0x233)]=!0x1,this['_connecting']=!0x0,this[_0x284a26(0x1c6)]=new Promise((_0x16cf87,_0x390da1)=>{var _0x2a599a=_0x284a26;this[_0x2a599a(0x1ed)]()[_0x2a599a(0x234)](_0x3023c4=>{var _0x184180=_0x2a599a;let _0x34271b=new _0x3023c4('ws://'+this['host']+':'+this[_0x184180(0x1e8)]);_0x34271b[_0x184180(0x1eb)]=()=>{var _0x1bb4eb=_0x184180;this['_connected']=!0x1,this[_0x1bb4eb(0x1f1)]=!0x1,this[_0x1bb4eb(0x239)]=!0x1,this['_attemptToReconnect'](),_0x390da1(new Error('logger\\x20websocket\\x20error'));},_0x34271b[_0x184180(0x1e6)]=()=>{var _0x80fecb=_0x184180;this[_0x80fecb(0x268)]||_0x34271b[_0x80fecb(0x1ba)]&&_0x34271b[_0x80fecb(0x1ba)][_0x80fecb(0x1e3)]&&_0x34271b[_0x80fecb(0x1ba)][_0x80fecb(0x1e3)](),_0x16cf87(_0x34271b);},_0x34271b[_0x184180(0x227)]=()=>{var _0x5b193b=_0x184180;this[_0x5b193b(0x1f5)]=!0x1,this[_0x5b193b(0x1f1)]=!0x1,this[_0x5b193b(0x233)]=!0x0,this[_0x5b193b(0x27a)]();},_0x34271b['onmessage']=_0x414ce6=>{var _0xb49565=_0x184180;try{_0x414ce6&&_0x414ce6[_0xb49565(0x1f3)]&&this[_0xb49565(0x268)]&&JSON[_0xb49565(0x21f)](_0x414ce6['data'])[_0xb49565(0x216)]===_0xb49565(0x1c3)&&this['global'][_0xb49565(0x1d3)][_0xb49565(0x1c3)]();}catch{}};})['then'](_0x8af837=>(this[_0x2a599a(0x1f5)]=!0x0,this[_0x2a599a(0x1f1)]=!0x1,this[_0x2a599a(0x233)]=!0x1,this[_0x2a599a(0x239)]=!0x0,_0x8af837))[_0x2a599a(0x279)](_0xb493ca=>(this[_0x2a599a(0x1f5)]=!0x1,this[_0x2a599a(0x1f1)]=!0x1,_0x390da1(new Error(_0x2a599a(0x20a)+_0xb493ca&&_0xb493ca[_0x2a599a(0x1c0)]))));}));}[_0x550420(0x27a)](){var _0x3b9378=_0x550420;clearTimeout(this['_reconnectTimeout']),this[_0x3b9378(0x1fe)]=setTimeout(()=>{var _0x379b8d=_0x3b9378;this[_0x379b8d(0x1f5)]||this[_0x379b8d(0x1f1)]||(this[_0x379b8d(0x241)](),this['_ws']?.[_0x379b8d(0x279)](()=>this[_0x379b8d(0x27a)]()));},0x1f4);}async[_0x550420(0x20e)](_0x293d84){var _0x15339d=_0x550420;try{if(!this[_0x15339d(0x239)])return;this['_allowedToConnectOnSend']&&this[_0x15339d(0x241)](),(await this['_ws'])['send'](JSON[_0x15339d(0x240)](_0x293d84));}catch(_0x42aee2){console['warn'](this[_0x15339d(0x24b)]+':\\x20'+_0x42aee2&&_0x42aee2[_0x15339d(0x1c0)]),this[_0x15339d(0x239)]=!0x1,this[_0x15339d(0x27a)]();}}};function H(_0x57cb77,_0x52c275,_0x3c8f46,_0x1cad4d,_0x4dbc67){var _0x2ba889=_0x550420;let _0x92206c=_0x3c8f46['split'](',')['map'](_0x892e8=>{var _0x547c98=_0x35a9;try{_0x57cb77[_0x547c98(0x1cf)]||((_0x4dbc67===_0x547c98(0x26c)||_0x4dbc67===_0x547c98(0x1d6))&&(_0x4dbc67+=_0x57cb77[_0x547c98(0x1b7)]?.[_0x547c98(0x1e9)]?.[_0x547c98(0x1d0)]?_0x547c98(0x1de):_0x547c98(0x20c)),_0x57cb77[_0x547c98(0x1cf)]={'id':+new Date(),'tool':_0x4dbc67});let _0xc98fcc=new V(_0x57cb77,_0x52c275,_0x892e8,_0x1cad4d);return _0xc98fcc['send'][_0x547c98(0x1be)](_0xc98fcc);}catch(_0x21ec5c){return console['warn']('logger\\x20failed\\x20to\\x20connect\\x20to\\x20host',_0x21ec5c&&_0x21ec5c['message']),()=>{};}});return _0x1c719b=>_0x92206c[_0x2ba889(0x201)](_0x1a5b8a=>_0x1a5b8a(_0x1c719b));}function X(_0x52edc7){var _0x201e82=_0x550420;let _0x49b9f7=function(_0x194ac3,_0x21aa92){return _0x21aa92-_0x194ac3;},_0x418819;if(_0x52edc7['performance'])_0x418819=function(){var _0x5df911=_0x35a9;return _0x52edc7[_0x5df911(0x25c)][_0x5df911(0x242)]();};else{if(_0x52edc7['process']&&_0x52edc7[_0x201e82(0x1b7)][_0x201e82(0x212)])_0x418819=function(){var _0x3be9ee=_0x201e82;return _0x52edc7[_0x3be9ee(0x1b7)][_0x3be9ee(0x212)]();},_0x49b9f7=function(_0xb23572,_0x35fbf1){return 0x3e8*(_0x35fbf1[0x0]-_0xb23572[0x0])+(_0x35fbf1[0x1]-_0xb23572[0x1])/0xf4240;};else try{let {performance:_0x3f7c40}=require(_0x201e82(0x220));_0x418819=function(){var _0x5c86f4=_0x201e82;return _0x3f7c40[_0x5c86f4(0x242)]();};}catch{_0x418819=function(){return+new Date();};}}return{'elapsed':_0x49b9f7,'timeStamp':_0x418819,'now':()=>Date[_0x201e82(0x242)]()};}function b(_0x28f06b,_0x457379,_0x37c74f){var _0x33f6d1=_0x550420;if(_0x28f06b['_consoleNinjaAllowedToStart']!==void 0x0)return _0x28f06b[_0x33f6d1(0x1ac)];let _0xa92f2c=_0x28f06b['process']?.[_0x33f6d1(0x1e9)]?.['node'];return _0xa92f2c&&_0x37c74f===_0x33f6d1(0x1bc)?_0x28f06b[_0x33f6d1(0x1ac)]=!0x1:_0x28f06b['_consoleNinjaAllowedToStart']=_0xa92f2c||!_0x457379||_0x28f06b['location']?.[_0x33f6d1(0x1bf)]&&_0x457379[_0x33f6d1(0x215)](_0x28f06b[_0x33f6d1(0x1d3)][_0x33f6d1(0x1bf)]),_0x28f06b[_0x33f6d1(0x1ac)];}function _0x421f(){var _0x598e9f=['nodeModules','688824cRCJFd','_socket','serialize','nuxt','hits','bind','hostname','message','failed\\x20to\\x20find\\x20WebSocket','get','reload','count','_property','_ws','depth','number','_isSet','_getOwnPropertySymbols','POSITIVE_INFINITY','stackTraceLimit','getPrototypeOf','','_console_ninja_session','node','7993944kmJFJI','_dateToString','location','date','_isPrimitiveType','remix','string','boolean','_setNodePermissions','argumentResolutionError','url','resolveGetters','value','\\x20server','49782','host',[\"localhost\",\"127.0.0.1\",\"example.cypress.io\",\"vm-icsdev-03\",\"10.2.0.6\"],'index','unref','constructor','positiveInfinity','onopen','__es'+'Module','port','versions','array','onerror','_blacklistedProperty','getWebSocketClass','toString','split','autoExpandLimit','_connecting','_console_ninja','data','Buffer','_connected','_Symbol','sort','hasOwnProperty','isArray','_keyStrRegExp','3885968FwKyzm','[object\\x20Array]','_treeNodePropertiesAfterFullValue','_reconnectTimeout','unknown','push','forEach','enumerable','length','function','autoExpand','reduceLimits','getOwnPropertyNames','127.0.0.1','getter','failed\\x20to\\x20connect\\x20to\\x20host:\\x20','substr','\\x20browser','log','send','_processTreeNodeResult','default','_objectToString','hrtime','create','Number','includes','method','_isUndefined','error','_p_name','null','console','_addProperty','set','autoExpandMaxDepth','parse','perf_hooks','_addObjectProperty','disabledTrace','totalStrLength','funcName','sortProps','strLength','onclose','join','_quotedRegExp','slice','parent','RegExp','cappedProps','_cleanNode','1.0.0','Set','autoExpandPropertyCount','_setNodeQueryPath','_allowedToConnectOnSend','then','indexOf','getOwnPropertySymbols','_propertyName','getOwnPropertyDescriptor','_allowedToSend','1512502CPQHZY','1079090OiUZBX','_treeNodePropertiesBeforeFullValue','_type','pathToFileURL','_addLoadNode','stringify','_connectToHost','now','level','19977993QHJeOe','_isMap','allStrLength','[object\\x20Set]','HTMLAllCollection','_p_','1680077819028','_sendErrorMessage','NEGATIVE_INFINITY','_WebSocketClass','webpack','_setNodeLabel','name','symbol','toLowerCase','elapsed','prototype','failed\\x20to\\x20send\\x20logs,\\x20refreshing\\x20the\\x20page\\x20may\\x20help','expressionsToEvaluate','_setNodeExpandableState','isExpressionToEvaluate','Map','timeEnd','_capIfString','performance','_isArray','String','capped','match','_sortProps','...','global','bigint','_hasMapOnItsPath','current','_setNodeExpressionPath','_inBrowser','call','props','timeStamp','next.js','_numberRegExp','_propertyAccessor','_getOwnPropertyDescriptor','_setNodeId','test','trace','type','Symbol','replace','autoExpandPreviousObjects','noFunctions','time','catch','_attemptToReconnect','elements','undefined','_getOwnPropertyNames','_hasSetOnItsPath','_undefined','[object\\x20Map]','valueOf','cappedElements','Boolean','_regExpToString','_isPrimitiveWrapperType','setter','_consoleNinjaAllowedToStart','_p_length','495110nnbOxv','_additionalMetadata','expId','nan','_isNegativeZero','_HTMLAllCollection','stack','[object\\x20Date]','object','process'];_0x421f=function(){return _0x598e9f;};return _0x421f();}((_0x2299bf,_0x4710e5,_0x249553,_0x47b51f,_0x2ebf68,_0x10e039,_0x19007c,_0x236a2b,_0x40c171)=>{var _0x5054da=_0x550420;if(_0x2299bf[_0x5054da(0x1f2)])return _0x2299bf['_console_ninja'];if(!b(_0x2299bf,_0x236a2b,_0x2ebf68))return _0x2299bf[_0x5054da(0x1f2)]={'consoleLog':()=>{},'consoleTrace':()=>{},'consoleTime':()=>{},'consoleTimeEnd':()=>{},'autoLog':()=>{},'autoTrace':()=>{},'autoTime':()=>{},'autoTimeEnd':()=>{}},_0x2299bf['_console_ninja'];let _0x541d22={'props':0x64,'elements':0x64,'strLength':0x400*0x32,'totalStrLength':0x400*0x32,'autoExpandLimit':0x1388,'autoExpandMaxDepth':0xa},_0x3cfe41={'props':0x5,'elements':0x5,'strLength':0x100,'totalStrLength':0x100*0x3,'autoExpandLimit':0x1e,'autoExpandMaxDepth':0x2},_0x436548=X(_0x2299bf),_0x47e0f5=_0x436548[_0x5054da(0x253)],_0x54c9a=_0x436548[_0x5054da(0x26b)],_0x4b4168=_0x436548['now'],_0x564616={'hits':{},'ts':{}},_0x1ddce5=_0x3836c2=>{_0x564616['ts'][_0x3836c2]=_0x54c9a();},_0x1ba25d=(_0x373367,_0x411d81)=>{var _0x594834=_0x5054da;let _0x1af5f9=_0x564616['ts'][_0x411d81];if(delete _0x564616['ts'][_0x411d81],_0x1af5f9){let _0x151bb5=_0x47e0f5(_0x1af5f9,_0x54c9a());_0x5e8e39(_0x5b6d37(_0x594834(0x278),_0x373367,_0x4b4168(),_0x20332d,[_0x151bb5],_0x411d81));}},_0x182d0a=_0x50d149=>_0x4ba5b5=>{var _0x386809=_0x5054da;try{_0x1ddce5(_0x4ba5b5),_0x50d149(_0x4ba5b5);}finally{_0x2299bf[_0x386809(0x21b)][_0x386809(0x278)]=_0x50d149;}},_0x377a30=_0x199ef7=>_0x3bcf25=>{var _0x36608e=_0x5054da;try{let [_0xb7c0f0,_0x3937e8]=_0x3bcf25[_0x36608e(0x1ef)](':logPointId:');_0x1ba25d(_0x3937e8,_0xb7c0f0),_0x199ef7(_0xb7c0f0);}finally{_0x2299bf[_0x36608e(0x21b)][_0x36608e(0x25a)]=_0x199ef7;}};_0x2299bf[_0x5054da(0x1f2)]={'consoleLog':(_0x71f12e,_0x404341)=>{var _0x3e36ae=_0x5054da;_0x2299bf[_0x3e36ae(0x21b)]['log'][_0x3e36ae(0x250)]!=='disabledLog'&&_0x5e8e39(_0x5b6d37(_0x3e36ae(0x20d),_0x71f12e,_0x4b4168(),_0x20332d,_0x404341));},'consoleTrace':(_0x1eb9b9,_0x1e9912)=>{var _0xee6a1e=_0x5054da;_0x2299bf[_0xee6a1e(0x21b)]['log']['name']!==_0xee6a1e(0x222)&&_0x5e8e39(_0x5b6d37(_0xee6a1e(0x272),_0x1eb9b9,_0x4b4168(),_0x20332d,_0x1e9912));},'consoleTime':()=>{var _0x41c4f3=_0x5054da;_0x2299bf[_0x41c4f3(0x21b)]['time']=_0x182d0a(_0x2299bf[_0x41c4f3(0x21b)][_0x41c4f3(0x278)]);},'consoleTimeEnd':()=>{var _0x1183e9=_0x5054da;_0x2299bf[_0x1183e9(0x21b)]['timeEnd']=_0x377a30(_0x2299bf[_0x1183e9(0x21b)][_0x1183e9(0x25a)]);},'autoLog':(_0x11c482,_0x4b789c)=>{var _0x381d2b=_0x5054da;_0x5e8e39(_0x5b6d37(_0x381d2b(0x20d),_0x4b789c,_0x4b4168(),_0x20332d,[_0x11c482]));},'autoTrace':(_0x293d13,_0x13dd0e)=>{var _0x326128=_0x5054da;_0x5e8e39(_0x5b6d37(_0x326128(0x272),_0x13dd0e,_0x4b4168(),_0x20332d,[_0x293d13]));},'autoTime':(_0x5f11ec,_0x4dc87a,_0x589078)=>{_0x1ddce5(_0x589078);},'autoTimeEnd':(_0x569d67,_0x552944,_0x19a592)=>{_0x1ba25d(_0x552944,_0x19a592);}};let _0x5e8e39=H(_0x2299bf,_0x4710e5,_0x249553,_0x47b51f,_0x2ebf68),_0x20332d=_0x2299bf[_0x5054da(0x1cf)];class _0x889d98{constructor(){var _0x4a713f=_0x5054da;this[_0x4a713f(0x1fa)]=/^(?!(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$)[_$a-zA-Z\\xA0-\\uFFFF][_$a-zA-Z0-9\\xA0-\\uFFFF]*$/,this['_numberRegExp']=/^(0|[1-9][0-9]*)$/,this['_quotedRegExp']=/'([^\\\\']|\\\\')*'/,this[_0x4a713f(0x27f)]=_0x2299bf[_0x4a713f(0x27c)],this[_0x4a713f(0x1b3)]=_0x2299bf['HTMLAllCollection'],this['_getOwnPropertyDescriptor']=Object[_0x4a713f(0x238)],this[_0x4a713f(0x27d)]=Object['getOwnPropertyNames'],this[_0x4a713f(0x1f6)]=_0x2299bf[_0x4a713f(0x274)],this[_0x4a713f(0x1a9)]=RegExp[_0x4a713f(0x254)][_0x4a713f(0x1ee)],this[_0x4a713f(0x1d2)]=Date['prototype'][_0x4a713f(0x1ee)];}[_0x5054da(0x1bb)](_0xa9ac0a,_0x2a9454,_0x34ad7c,_0x1c958f){var _0x48cef1=_0x5054da,_0x27beb8=this,_0x2f16a7=_0x34ad7c[_0x48cef1(0x205)];function _0x28a293(_0x52f18e,_0x1916b1,_0xad2f73){var _0xe86050=_0x48cef1;_0x1916b1[_0xe86050(0x273)]=_0xe86050(0x1ff),_0x1916b1[_0xe86050(0x218)]=_0x52f18e['message'],_0x43c8ba=_0xad2f73[_0xe86050(0x1d0)]['current'],_0xad2f73[_0xe86050(0x1d0)][_0xe86050(0x266)]=_0x1916b1,_0x27beb8[_0xe86050(0x23c)](_0x1916b1,_0xad2f73);}if(_0x2a9454&&_0x2a9454[_0x48cef1(0x1da)])_0x28a293(_0x2a9454,_0xa9ac0a,_0x34ad7c);else try{_0x34ad7c[_0x48cef1(0x243)]++,_0x34ad7c['autoExpand']&&_0x34ad7c['autoExpandPreviousObjects']['push'](_0x2a9454);var _0x1889af,_0x3409c7,_0x13df52,_0x6db23f,_0x39fd72=[],_0x5f086a=[],_0x149a50,_0xb792e0=this[_0x48cef1(0x23d)](_0x2a9454),_0x42dcfd=_0xb792e0===_0x48cef1(0x1ea),_0x104ca3=!0x1,_0x38d02a=_0xb792e0===_0x48cef1(0x204),_0x5d56a5=this[_0x48cef1(0x1d5)](_0xb792e0),_0x37548e=this[_0x48cef1(0x1aa)](_0xb792e0),_0x452c26=_0x5d56a5||_0x37548e,_0x16d594={},_0x2b6099=0x0,_0x42f249=!0x1,_0x43c8ba,_0x330c04=/^(([1-9]{1}[0-9]*)|0)$/;if(_0x34ad7c['depth']){if(_0x42dcfd){if(_0x3409c7=_0x2a9454[_0x48cef1(0x203)],_0x3409c7>_0x34ad7c[_0x48cef1(0x27b)]){for(_0x13df52=0x0,_0x6db23f=_0x34ad7c[_0x48cef1(0x27b)],_0x1889af=_0x13df52;_0x1889af<_0x6db23f;_0x1889af++)_0x5f086a['push'](_0x27beb8[_0x48cef1(0x21c)](_0x39fd72,_0x2a9454,_0xb792e0,_0x1889af,_0x34ad7c));_0xa9ac0a[_0x48cef1(0x282)]=!0x0;}else{for(_0x13df52=0x0,_0x6db23f=_0x3409c7,_0x1889af=_0x13df52;_0x1889af<_0x6db23f;_0x1889af++)_0x5f086a[_0x48cef1(0x200)](_0x27beb8['_addProperty'](_0x39fd72,_0x2a9454,_0xb792e0,_0x1889af,_0x34ad7c));}_0x34ad7c[_0x48cef1(0x231)]+=_0x5f086a['length'];}if(!(_0xb792e0===_0x48cef1(0x21a)||_0xb792e0===_0x48cef1(0x27c))&&!_0x5d56a5&&_0xb792e0!==_0x48cef1(0x25e)&&_0xb792e0!==_0x48cef1(0x1f4)&&_0xb792e0!==_0x48cef1(0x264)){var _0x407a16=_0x1c958f[_0x48cef1(0x26a)]||_0x34ad7c[_0x48cef1(0x26a)];if(this['_isSet'](_0x2a9454)?(_0x1889af=0x0,_0x2a9454[_0x48cef1(0x201)](function(_0x11e0c4){var _0x4fb539=_0x48cef1;if(_0x2b6099++,_0x34ad7c[_0x4fb539(0x231)]++,_0x2b6099>_0x407a16){_0x42f249=!0x0;return;}if(!_0x34ad7c['isExpressionToEvaluate']&&_0x34ad7c[_0x4fb539(0x205)]&&_0x34ad7c[_0x4fb539(0x231)]>_0x34ad7c[_0x4fb539(0x1f0)]){_0x42f249=!0x0;return;}_0x5f086a['push'](_0x27beb8['_addProperty'](_0x39fd72,_0x2a9454,_0x4fb539(0x230),_0x1889af++,_0x34ad7c,function(_0xd43dda){return function(){return _0xd43dda;};}(_0x11e0c4)));})):this[_0x48cef1(0x245)](_0x2a9454)&&_0x2a9454[_0x48cef1(0x201)](function(_0x283d72,_0x14a79f){var _0x15725c=_0x48cef1;if(_0x2b6099++,_0x34ad7c[_0x15725c(0x231)]++,_0x2b6099>_0x407a16){_0x42f249=!0x0;return;}if(!_0x34ad7c['isExpressionToEvaluate']&&_0x34ad7c[_0x15725c(0x205)]&&_0x34ad7c[_0x15725c(0x231)]>_0x34ad7c[_0x15725c(0x1f0)]){_0x42f249=!0x0;return;}var _0x37a299=_0x14a79f[_0x15725c(0x1ee)]();_0x37a299[_0x15725c(0x203)]>0x64&&(_0x37a299=_0x37a299[_0x15725c(0x22a)](0x0,0x64)+_0x15725c(0x262)),_0x5f086a[_0x15725c(0x200)](_0x27beb8[_0x15725c(0x21c)](_0x39fd72,_0x2a9454,_0x15725c(0x259),_0x37a299,_0x34ad7c,function(_0x1131bf){return function(){return _0x1131bf;};}(_0x283d72)));}),!_0x104ca3){try{for(_0x149a50 in _0x2a9454)if(!(_0x42dcfd&&_0x330c04['test'](_0x149a50))&&!this[_0x48cef1(0x1ec)](_0x2a9454,_0x149a50,_0x34ad7c)){if(_0x2b6099++,_0x34ad7c[_0x48cef1(0x231)]++,_0x2b6099>_0x407a16){_0x42f249=!0x0;break;}if(!_0x34ad7c[_0x48cef1(0x258)]&&_0x34ad7c[_0x48cef1(0x205)]&&_0x34ad7c[_0x48cef1(0x231)]>_0x34ad7c[_0x48cef1(0x1f0)]){_0x42f249=!0x0;break;}_0x5f086a[_0x48cef1(0x200)](_0x27beb8[_0x48cef1(0x221)](_0x39fd72,_0x16d594,_0x2a9454,_0xb792e0,_0x149a50,_0x34ad7c));}}catch{}if(_0x16d594[_0x48cef1(0x1ad)]=!0x0,_0x38d02a&&(_0x16d594[_0x48cef1(0x219)]=!0x0),!_0x42f249){var _0x527e16=[]['concat'](this[_0x48cef1(0x27d)](_0x2a9454))['concat'](this[_0x48cef1(0x1ca)](_0x2a9454));for(_0x1889af=0x0,_0x3409c7=_0x527e16[_0x48cef1(0x203)];_0x1889af<_0x3409c7;_0x1889af++)if(_0x149a50=_0x527e16[_0x1889af],!(_0x42dcfd&&_0x330c04[_0x48cef1(0x271)](_0x149a50[_0x48cef1(0x1ee)]()))&&!this[_0x48cef1(0x1ec)](_0x2a9454,_0x149a50,_0x34ad7c)&&!_0x16d594['_p_'+_0x149a50['toString']()]){if(_0x2b6099++,_0x34ad7c[_0x48cef1(0x231)]++,_0x2b6099>_0x407a16){_0x42f249=!0x0;break;}if(!_0x34ad7c['isExpressionToEvaluate']&&_0x34ad7c[_0x48cef1(0x205)]&&_0x34ad7c[_0x48cef1(0x231)]>_0x34ad7c[_0x48cef1(0x1f0)]){_0x42f249=!0x0;break;}_0x5f086a['push'](_0x27beb8[_0x48cef1(0x221)](_0x39fd72,_0x16d594,_0x2a9454,_0xb792e0,_0x149a50,_0x34ad7c));}}}}}if(_0xa9ac0a[_0x48cef1(0x273)]=_0xb792e0,_0x452c26?(_0xa9ac0a['value']=_0x2a9454[_0x48cef1(0x281)](),this[_0x48cef1(0x25b)](_0xb792e0,_0xa9ac0a,_0x34ad7c,_0x1c958f)):_0xb792e0==='date'?_0xa9ac0a[_0x48cef1(0x1dd)]=this[_0x48cef1(0x1d2)][_0x48cef1(0x269)](_0x2a9454):_0xb792e0===_0x48cef1(0x22c)?_0xa9ac0a[_0x48cef1(0x1dd)]=this[_0x48cef1(0x1a9)]['call'](_0x2a9454):_0xb792e0===_0x48cef1(0x251)&&this[_0x48cef1(0x1f6)]?_0xa9ac0a[_0x48cef1(0x1dd)]=this[_0x48cef1(0x1f6)]['prototype'][_0x48cef1(0x1ee)]['call'](_0x2a9454):!_0x34ad7c[_0x48cef1(0x1c7)]&&!(_0xb792e0===_0x48cef1(0x21a)||_0xb792e0===_0x48cef1(0x27c))&&(delete _0xa9ac0a[_0x48cef1(0x1dd)],_0xa9ac0a[_0x48cef1(0x25f)]=!0x0),_0x42f249&&(_0xa9ac0a[_0x48cef1(0x22d)]=!0x0),_0x43c8ba=_0x34ad7c[_0x48cef1(0x1d0)][_0x48cef1(0x266)],_0x34ad7c['node'][_0x48cef1(0x266)]=_0xa9ac0a,this[_0x48cef1(0x23c)](_0xa9ac0a,_0x34ad7c),_0x5f086a['length']){for(_0x1889af=0x0,_0x3409c7=_0x5f086a[_0x48cef1(0x203)];_0x1889af<_0x3409c7;_0x1889af++)_0x5f086a[_0x1889af](_0x1889af);}_0x39fd72[_0x48cef1(0x203)]&&(_0xa9ac0a['props']=_0x39fd72);}catch(_0x3dd833){_0x28a293(_0x3dd833,_0xa9ac0a,_0x34ad7c);}return this[_0x48cef1(0x1af)](_0x2a9454,_0xa9ac0a),this[_0x48cef1(0x1fd)](_0xa9ac0a,_0x34ad7c),_0x34ad7c[_0x48cef1(0x1d0)]['current']=_0x43c8ba,_0x34ad7c['level']--,_0x34ad7c[_0x48cef1(0x205)]=_0x2f16a7,_0x34ad7c[_0x48cef1(0x205)]&&_0x34ad7c['autoExpandPreviousObjects']['pop'](),_0xa9ac0a;}[_0x5054da(0x1ca)](_0x157176){var _0x47d189=_0x5054da;return Object[_0x47d189(0x236)]?Object['getOwnPropertySymbols'](_0x157176):[];}[_0x5054da(0x1c9)](_0x371010){var _0x1a81a8=_0x5054da;return!!(_0x371010&&_0x2299bf[_0x1a81a8(0x230)]&&this[_0x1a81a8(0x211)](_0x371010)===_0x1a81a8(0x247)&&_0x371010[_0x1a81a8(0x201)]);}[_0x5054da(0x1ec)](_0x2916ac,_0x33b6a6,_0x495ad3){var _0x466b0a=_0x5054da;return _0x495ad3[_0x466b0a(0x277)]?typeof _0x2916ac[_0x33b6a6]=='function':!0x1;}[_0x5054da(0x23d)](_0x408311){var _0x2fdb00=_0x5054da,_0x1ee810='';return _0x1ee810=typeof _0x408311,_0x1ee810===_0x2fdb00(0x1b6)?this[_0x2fdb00(0x211)](_0x408311)===_0x2fdb00(0x1fc)?_0x1ee810=_0x2fdb00(0x1ea):this[_0x2fdb00(0x211)](_0x408311)===_0x2fdb00(0x1b5)?_0x1ee810=_0x2fdb00(0x1d4):_0x408311===null?_0x1ee810=_0x2fdb00(0x21a):_0x408311['constructor']&&(_0x1ee810=_0x408311[_0x2fdb00(0x1e4)][_0x2fdb00(0x250)]||_0x1ee810):_0x1ee810===_0x2fdb00(0x27c)&&this[_0x2fdb00(0x1b3)]&&_0x408311 instanceof this[_0x2fdb00(0x1b3)]&&(_0x1ee810=_0x2fdb00(0x248)),_0x1ee810;}[_0x5054da(0x211)](_0x3867a7){var _0x916ff5=_0x5054da;return Object[_0x916ff5(0x254)][_0x916ff5(0x1ee)][_0x916ff5(0x269)](_0x3867a7);}[_0x5054da(0x1d5)](_0x1c62c6){var _0x1388b3=_0x5054da;return _0x1c62c6===_0x1388b3(0x1d8)||_0x1c62c6==='string'||_0x1c62c6===_0x1388b3(0x1c8);}[_0x5054da(0x1aa)](_0x39a550){var _0x2077f3=_0x5054da;return _0x39a550===_0x2077f3(0x283)||_0x39a550===_0x2077f3(0x25e)||_0x39a550===_0x2077f3(0x214);}['_addProperty'](_0x33a5ad,_0xbcd798,_0x817e49,_0x5cf3cf,_0x3d86e5,_0x4b5ff2){var _0x3bf870=this;return function(_0x4729fc){var _0x1e546d=_0x35a9,_0x3908be=_0x3d86e5[_0x1e546d(0x1d0)][_0x1e546d(0x266)],_0x12d84c=_0x3d86e5['node'][_0x1e546d(0x1e2)],_0x5e9bbc=_0x3d86e5[_0x1e546d(0x1d0)]['parent'];_0x3d86e5['node'][_0x1e546d(0x22b)]=_0x3908be,_0x3d86e5[_0x1e546d(0x1d0)][_0x1e546d(0x1e2)]=typeof _0x5cf3cf=='number'?_0x5cf3cf:_0x4729fc,_0x33a5ad[_0x1e546d(0x200)](_0x3bf870[_0x1e546d(0x1c5)](_0xbcd798,_0x817e49,_0x5cf3cf,_0x3d86e5,_0x4b5ff2)),_0x3d86e5[_0x1e546d(0x1d0)][_0x1e546d(0x22b)]=_0x5e9bbc,_0x3d86e5['node'][_0x1e546d(0x1e2)]=_0x12d84c;};}[_0x5054da(0x221)](_0x495876,_0x827eb8,_0x4f27c7,_0x3a13cc,_0x472295,_0x1a5058,_0x25dc8f){var _0x52373f=_0x5054da,_0x5dc63a=this;return _0x827eb8[_0x52373f(0x249)+_0x472295['toString']()]=!0x0,function(_0x5d9c05){var _0x1679f1=_0x52373f,_0x56e2b6=_0x1a5058[_0x1679f1(0x1d0)]['current'],_0x26555d=_0x1a5058[_0x1679f1(0x1d0)][_0x1679f1(0x1e2)],_0x3a318e=_0x1a5058['node'][_0x1679f1(0x22b)];_0x1a5058['node']['parent']=_0x56e2b6,_0x1a5058[_0x1679f1(0x1d0)]['index']=_0x5d9c05,_0x495876['push'](_0x5dc63a[_0x1679f1(0x1c5)](_0x4f27c7,_0x3a13cc,_0x472295,_0x1a5058,_0x25dc8f)),_0x1a5058[_0x1679f1(0x1d0)][_0x1679f1(0x22b)]=_0x3a318e,_0x1a5058['node'][_0x1679f1(0x1e2)]=_0x26555d;};}[_0x5054da(0x1c5)](_0x22eb66,_0x294cbf,_0x58d86a,_0x225e00,_0x46b0f9){var _0x30fa19=_0x5054da,_0x28e20a=this;_0x46b0f9||(_0x46b0f9=function(_0x4091bb,_0x12ded1){return _0x4091bb[_0x12ded1];});var _0x27dfaa=_0x58d86a['toString'](),_0x22af03=_0x225e00[_0x30fa19(0x256)]||{},_0x237de8=_0x225e00[_0x30fa19(0x1c7)],_0x2d7900=_0x225e00['isExpressionToEvaluate'];try{var _0x3eaccb=this[_0x30fa19(0x245)](_0x22eb66),_0x3a7e37=_0x27dfaa;_0x3eaccb&&_0x3a7e37[0x0]==='\\x27'&&(_0x3a7e37=_0x3a7e37['substr'](0x1,_0x3a7e37[_0x30fa19(0x203)]-0x2));var _0x11bc2e=_0x225e00[_0x30fa19(0x256)]=_0x22af03['_p_'+_0x3a7e37];_0x11bc2e&&(_0x225e00['depth']=_0x225e00[_0x30fa19(0x1c7)]+0x1),_0x225e00[_0x30fa19(0x258)]=!!_0x11bc2e;var _0x1e11a7=typeof _0x58d86a==_0x30fa19(0x251),_0x51096d={'name':_0x1e11a7||_0x3eaccb?_0x27dfaa:this[_0x30fa19(0x237)](_0x27dfaa)};if(_0x1e11a7&&(_0x51096d['symbol']=!0x0),!(_0x294cbf===_0x30fa19(0x1ea)||_0x294cbf==='Error')){var _0x508e9f=this[_0x30fa19(0x26f)](_0x22eb66,_0x58d86a);if(_0x508e9f&&(_0x508e9f[_0x30fa19(0x21d)]&&(_0x51096d[_0x30fa19(0x1ab)]=!0x0),_0x508e9f[_0x30fa19(0x1c2)]&&!_0x11bc2e&&!_0x225e00['resolveGetters']))return _0x51096d[_0x30fa19(0x209)]=!0x0,this[_0x30fa19(0x20f)](_0x51096d,_0x225e00),_0x51096d;}var _0x365abd;try{_0x365abd=_0x46b0f9(_0x22eb66,_0x58d86a);}catch(_0x402641){return _0x51096d={'name':_0x27dfaa,'type':_0x30fa19(0x1ff),'error':_0x402641[_0x30fa19(0x1c0)]},this[_0x30fa19(0x20f)](_0x51096d,_0x225e00),_0x51096d;}var _0x3fad3b=this[_0x30fa19(0x23d)](_0x365abd),_0x3fcccf=this['_isPrimitiveType'](_0x3fad3b);if(_0x51096d[_0x30fa19(0x273)]=_0x3fad3b,_0x3fcccf)this[_0x30fa19(0x20f)](_0x51096d,_0x225e00,_0x365abd,function(){_0x51096d['value']=_0x365abd['valueOf'](),!_0x11bc2e&&_0x28e20a['_capIfString'](_0x3fad3b,_0x51096d,_0x225e00,{});});else{var _0x3e1f6f=_0x225e00[_0x30fa19(0x205)]&&_0x225e00[_0x30fa19(0x243)]<_0x225e00['autoExpandMaxDepth']&&_0x225e00[_0x30fa19(0x276)][_0x30fa19(0x235)](_0x365abd)<0x0&&_0x3fad3b!==_0x30fa19(0x204)&&_0x225e00[_0x30fa19(0x231)]<_0x225e00[_0x30fa19(0x1f0)];_0x3e1f6f||_0x225e00[_0x30fa19(0x243)]<_0x237de8||_0x11bc2e?(this[_0x30fa19(0x1bb)](_0x51096d,_0x365abd,_0x225e00,_0x11bc2e||{}),this[_0x30fa19(0x1af)](_0x365abd,_0x51096d)):this[_0x30fa19(0x20f)](_0x51096d,_0x225e00,_0x365abd,function(){var _0x2fb74a=_0x30fa19;_0x3fad3b==='null'||_0x3fad3b===_0x2fb74a(0x27c)||(delete _0x51096d[_0x2fb74a(0x1dd)],_0x51096d['capped']=!0x0);});}return _0x51096d;}finally{_0x225e00['expressionsToEvaluate']=_0x22af03,_0x225e00[_0x30fa19(0x1c7)]=_0x237de8,_0x225e00[_0x30fa19(0x258)]=_0x2d7900;}}['_capIfString'](_0x330daf,_0x25df49,_0x1855a7,_0x579b41){var _0x5e658e=_0x5054da,_0x24ab86=_0x579b41[_0x5e658e(0x226)]||_0x1855a7[_0x5e658e(0x226)];if((_0x330daf===_0x5e658e(0x1d7)||_0x330daf===_0x5e658e(0x25e))&&_0x25df49[_0x5e658e(0x1dd)]){let _0x496223=_0x25df49[_0x5e658e(0x1dd)][_0x5e658e(0x203)];_0x1855a7[_0x5e658e(0x246)]+=_0x496223,_0x1855a7[_0x5e658e(0x246)]>_0x1855a7[_0x5e658e(0x223)]?(_0x25df49[_0x5e658e(0x25f)]='',delete _0x25df49[_0x5e658e(0x1dd)]):_0x496223>_0x24ab86&&(_0x25df49[_0x5e658e(0x25f)]=_0x25df49[_0x5e658e(0x1dd)][_0x5e658e(0x20b)](0x0,_0x24ab86),delete _0x25df49[_0x5e658e(0x1dd)]);}}[_0x5054da(0x245)](_0xbcf1d0){var _0x25c740=_0x5054da;return!!(_0xbcf1d0&&_0x2299bf[_0x25c740(0x259)]&&this[_0x25c740(0x211)](_0xbcf1d0)===_0x25c740(0x280)&&_0xbcf1d0[_0x25c740(0x201)]);}['_propertyName'](_0x275cf8){var _0x1cd523=_0x5054da;if(_0x275cf8[_0x1cd523(0x260)](/^\\d+$/))return _0x275cf8;var _0x522642;try{_0x522642=JSON[_0x1cd523(0x240)](''+_0x275cf8);}catch{_0x522642='\\x22'+this['_objectToString'](_0x275cf8)+'\\x22';}return _0x522642[_0x1cd523(0x260)](/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?_0x522642=_0x522642['substr'](0x1,_0x522642['length']-0x2):_0x522642=_0x522642[_0x1cd523(0x275)](/'/g,'\\x5c\\x27')[_0x1cd523(0x275)](/\\\\\"/g,'\\x22')[_0x1cd523(0x275)](/(^\"|\"$)/g,'\\x27'),_0x522642;}['_processTreeNodeResult'](_0x5f2b6a,_0x2d7b91,_0x43332c,_0x8a63d0){var _0x468fb4=_0x5054da;this[_0x468fb4(0x23c)](_0x5f2b6a,_0x2d7b91),_0x8a63d0&&_0x8a63d0(),this[_0x468fb4(0x1af)](_0x43332c,_0x5f2b6a),this[_0x468fb4(0x1fd)](_0x5f2b6a,_0x2d7b91);}[_0x5054da(0x23c)](_0x4cadb0,_0x342983){var _0x12c1ca=_0x5054da;this[_0x12c1ca(0x270)](_0x4cadb0,_0x342983),this[_0x12c1ca(0x232)](_0x4cadb0,_0x342983),this[_0x12c1ca(0x267)](_0x4cadb0,_0x342983),this[_0x12c1ca(0x1d9)](_0x4cadb0,_0x342983);}['_setNodeId'](_0x5119a5,_0x2ffa79){}[_0x5054da(0x232)](_0x52c95b,_0x1c2b8b){}[_0x5054da(0x24f)](_0x3048c8,_0x4f3710){}[_0x5054da(0x217)](_0x3cabbf){var _0x3d52de=_0x5054da;return _0x3cabbf===this[_0x3d52de(0x27f)];}[_0x5054da(0x1fd)](_0x238f15,_0x1efec6){var _0x1aa973=_0x5054da;this[_0x1aa973(0x24f)](_0x238f15,_0x1efec6),this[_0x1aa973(0x257)](_0x238f15),_0x1efec6[_0x1aa973(0x225)]&&this[_0x1aa973(0x261)](_0x238f15),this['_addFunctionsNode'](_0x238f15,_0x1efec6),this[_0x1aa973(0x23f)](_0x238f15,_0x1efec6),this[_0x1aa973(0x22e)](_0x238f15);}['_additionalMetadata'](_0x46b31d,_0x214576){var _0x48fdfe=_0x5054da;try{_0x46b31d&&typeof _0x46b31d[_0x48fdfe(0x203)]==_0x48fdfe(0x1c8)&&(_0x214576[_0x48fdfe(0x203)]=_0x46b31d['length']);}catch{}if(_0x214576[_0x48fdfe(0x273)]===_0x48fdfe(0x1c8)||_0x214576[_0x48fdfe(0x273)]===_0x48fdfe(0x214)){if(isNaN(_0x214576[_0x48fdfe(0x1dd)]))_0x214576[_0x48fdfe(0x1b1)]=!0x0,delete _0x214576[_0x48fdfe(0x1dd)];else switch(_0x214576[_0x48fdfe(0x1dd)]){case Number[_0x48fdfe(0x1cb)]:_0x214576[_0x48fdfe(0x1e5)]=!0x0,delete _0x214576[_0x48fdfe(0x1dd)];break;case Number[_0x48fdfe(0x24c)]:_0x214576['negativeInfinity']=!0x0,delete _0x214576['value'];break;case 0x0:this[_0x48fdfe(0x1b2)](_0x214576[_0x48fdfe(0x1dd)])&&(_0x214576['negativeZero']=!0x0);break;}}else _0x214576[_0x48fdfe(0x273)]==='function'&&typeof _0x46b31d[_0x48fdfe(0x250)]==_0x48fdfe(0x1d7)&&_0x46b31d[_0x48fdfe(0x250)]&&_0x214576[_0x48fdfe(0x250)]&&_0x46b31d[_0x48fdfe(0x250)]!==_0x214576[_0x48fdfe(0x250)]&&(_0x214576[_0x48fdfe(0x224)]=_0x46b31d['name']);}[_0x5054da(0x1b2)](_0x1cbb41){var _0x1129ce=_0x5054da;return 0x1/_0x1cbb41===Number[_0x1129ce(0x24c)];}[_0x5054da(0x261)](_0x275265){var _0x9c8ff=_0x5054da;!_0x275265[_0x9c8ff(0x26a)]||!_0x275265[_0x9c8ff(0x26a)]['length']||_0x275265[_0x9c8ff(0x273)]==='array'||_0x275265[_0x9c8ff(0x273)]===_0x9c8ff(0x259)||_0x275265[_0x9c8ff(0x273)]===_0x9c8ff(0x230)||_0x275265[_0x9c8ff(0x26a)][_0x9c8ff(0x1f7)](function(_0xd02057,_0x339e80){var _0x1f3204=_0x9c8ff,_0x51d4e3=_0xd02057['name'][_0x1f3204(0x252)](),_0x4f4fec=_0x339e80[_0x1f3204(0x250)]['toLowerCase']();return _0x51d4e3<_0x4f4fec?-0x1:_0x51d4e3>_0x4f4fec?0x1:0x0;});}['_addFunctionsNode'](_0x59f791,_0x400b38){var _0x5028b0=_0x5054da;if(!(_0x400b38[_0x5028b0(0x277)]||!_0x59f791['props']||!_0x59f791[_0x5028b0(0x26a)]['length'])){for(var _0x11d62b=[],_0xc0db36=[],_0x162600=0x0,_0xa6d2ba=_0x59f791['props'][_0x5028b0(0x203)];_0x162600<_0xa6d2ba;_0x162600++){var _0x2ab628=_0x59f791[_0x5028b0(0x26a)][_0x162600];_0x2ab628[_0x5028b0(0x273)]==='function'?_0x11d62b['push'](_0x2ab628):_0xc0db36['push'](_0x2ab628);}if(!(!_0xc0db36[_0x5028b0(0x203)]||_0x11d62b['length']<=0x1)){_0x59f791[_0x5028b0(0x26a)]=_0xc0db36;var _0x590ab3={'functionsNode':!0x0,'props':_0x11d62b};this[_0x5028b0(0x270)](_0x590ab3,_0x400b38),this[_0x5028b0(0x24f)](_0x590ab3,_0x400b38),this[_0x5028b0(0x257)](_0x590ab3),this[_0x5028b0(0x1d9)](_0x590ab3,_0x400b38),_0x590ab3['id']+='\\x20f',_0x59f791[_0x5028b0(0x26a)]['unshift'](_0x590ab3);}}}['_addLoadNode'](_0x30a7dd,_0x50a77a){}['_setNodeExpandableState'](_0x55e454){}[_0x5054da(0x25d)](_0x19a9e7){var _0x2507f9=_0x5054da;return Array[_0x2507f9(0x1f9)](_0x19a9e7)||typeof _0x19a9e7=='object'&&this[_0x2507f9(0x211)](_0x19a9e7)===_0x2507f9(0x1fc);}[_0x5054da(0x1d9)](_0x3c0c27,_0x35cbf2){}['_cleanNode'](_0x4dee3d){var _0x56591f=_0x5054da;delete _0x4dee3d['_hasSymbolPropertyOnItsPath'],delete _0x4dee3d[_0x56591f(0x27e)],delete _0x4dee3d[_0x56591f(0x265)];}[_0x5054da(0x267)](_0x25e6d6,_0x7c4c36){}[_0x5054da(0x26e)](_0x2f576f){var _0x507335=_0x5054da;return _0x2f576f?_0x2f576f[_0x507335(0x260)](this[_0x507335(0x26d)])?'['+_0x2f576f+']':_0x2f576f[_0x507335(0x260)](this['_keyStrRegExp'])?'.'+_0x2f576f:_0x2f576f[_0x507335(0x260)](this[_0x507335(0x229)])?'['+_0x2f576f+']':'[\\x27'+_0x2f576f+'\\x27]':'';}}let _0x452c1c=new _0x889d98();function _0x5b6d37(_0x598ec4,_0x18cd68,_0x3b08d8,_0x1a7c84,_0x30fa21,_0x9d0b3c){var _0x4c51c3=_0x5054da;let _0x5bad71,_0x296c50;try{_0x296c50=_0x54c9a(),_0x5bad71=_0x564616[_0x18cd68],!_0x5bad71||_0x296c50-_0x5bad71['ts']>0x1f4&&_0x5bad71[_0x4c51c3(0x1c4)]&&_0x5bad71[_0x4c51c3(0x278)]/_0x5bad71[_0x4c51c3(0x1c4)]<0x64?(_0x564616[_0x18cd68]=_0x5bad71={'count':0x0,'time':0x0,'ts':_0x296c50},_0x564616[_0x4c51c3(0x1bd)]={}):_0x296c50-_0x564616[_0x4c51c3(0x1bd)]['ts']>0x32&&_0x564616[_0x4c51c3(0x1bd)][_0x4c51c3(0x1c4)]&&_0x564616[_0x4c51c3(0x1bd)][_0x4c51c3(0x278)]/_0x564616[_0x4c51c3(0x1bd)][_0x4c51c3(0x1c4)]<0x64&&(_0x564616[_0x4c51c3(0x1bd)]={});let _0x3c1d7a=[],_0x51b2fa=_0x5bad71['reduceLimits']||_0x564616[_0x4c51c3(0x1bd)][_0x4c51c3(0x206)]?_0x3cfe41:_0x541d22,_0x34f79d=_0xf9d7fc=>{var _0x4483bc=_0x4c51c3;let _0x43c56c={};return _0x43c56c[_0x4483bc(0x26a)]=_0xf9d7fc[_0x4483bc(0x26a)],_0x43c56c[_0x4483bc(0x27b)]=_0xf9d7fc['elements'],_0x43c56c[_0x4483bc(0x226)]=_0xf9d7fc[_0x4483bc(0x226)],_0x43c56c[_0x4483bc(0x223)]=_0xf9d7fc[_0x4483bc(0x223)],_0x43c56c[_0x4483bc(0x1f0)]=_0xf9d7fc['autoExpandLimit'],_0x43c56c[_0x4483bc(0x21e)]=_0xf9d7fc[_0x4483bc(0x21e)],_0x43c56c[_0x4483bc(0x225)]=!0x1,_0x43c56c[_0x4483bc(0x277)]=!_0x40c171,_0x43c56c['depth']=0x1,_0x43c56c['level']=0x0,_0x43c56c[_0x4483bc(0x1b0)]='root_exp_id',_0x43c56c['rootExpression']='root_exp',_0x43c56c[_0x4483bc(0x205)]=!0x0,_0x43c56c[_0x4483bc(0x276)]=[],_0x43c56c[_0x4483bc(0x231)]=0x0,_0x43c56c[_0x4483bc(0x1dc)]=!0x0,_0x43c56c[_0x4483bc(0x246)]=0x0,_0x43c56c[_0x4483bc(0x1d0)]={'current':void 0x0,'parent':void 0x0,'index':0x0},_0x43c56c;};for(var _0x4d448c=0x0;_0x4d448c<_0x30fa21[_0x4c51c3(0x203)];_0x4d448c++)_0x3c1d7a[_0x4c51c3(0x200)](_0x452c1c['serialize']({'timeNode':_0x598ec4===_0x4c51c3(0x278)||void 0x0},_0x30fa21[_0x4d448c],_0x34f79d(_0x51b2fa),{}));if(_0x598ec4==='trace'){let _0x50448c=Error['stackTraceLimit'];try{Error['stackTraceLimit']=0x1/0x0,_0x3c1d7a['push'](_0x452c1c[_0x4c51c3(0x1bb)]({'stackNode':!0x0},new Error()[_0x4c51c3(0x1b4)],_0x34f79d(_0x51b2fa),{'strLength':0x1/0x0}));}finally{Error[_0x4c51c3(0x1cc)]=_0x50448c;}}return{'method':'log','version':_0x10e039,'args':[{'id':_0x18cd68,'ts':_0x3b08d8,'args':_0x3c1d7a,'context':_0x9d0b3c,'session':_0x1a7c84}]};}catch(_0x51da68){return{'method':_0x4c51c3(0x20d),'version':_0x10e039,'args':[{'id':_0x18cd68,'ts':_0x3b08d8,'args':[{'type':_0x4c51c3(0x1ff),'error':_0x51da68&&_0x51da68[_0x4c51c3(0x1c0)],'context':_0x9d0b3c,'session':_0x1a7c84}]}]};}finally{try{if(_0x5bad71&&_0x296c50){let _0x575256=_0x54c9a();_0x5bad71[_0x4c51c3(0x1c4)]++,_0x5bad71[_0x4c51c3(0x278)]+=_0x47e0f5(_0x296c50,_0x575256),_0x5bad71['ts']=_0x575256,_0x564616[_0x4c51c3(0x1bd)][_0x4c51c3(0x1c4)]++,_0x564616[_0x4c51c3(0x1bd)]['time']+=_0x47e0f5(_0x296c50,_0x575256),_0x564616[_0x4c51c3(0x1bd)]['ts']=_0x575256,(_0x5bad71['count']>0x32||_0x5bad71[_0x4c51c3(0x278)]>0x64)&&(_0x5bad71[_0x4c51c3(0x206)]=!0x0),(_0x564616['hits'][_0x4c51c3(0x1c4)]>0x3e8||_0x564616[_0x4c51c3(0x1bd)][_0x4c51c3(0x278)]>0x12c)&&(_0x564616[_0x4c51c3(0x1bd)][_0x4c51c3(0x206)]=!0x0);}}catch{}}}return _0x2299bf['_console_ninja'];})(globalThis,_0x550420(0x208),_0x550420(0x1df),\"c:\\\\Users\\\\ChrisLocal\\\\.vscode\\\\extensions\\\\wallabyjs.console-ninja-0.0.85\\\\node_modules\",_0x550420(0x24e),_0x550420(0x22f),_0x550420(0x24a),_0x550420(0x1e1),_0x550420(0x1ce));");
}
catch (e) { } }
;
function oo_oo(i, ...v) { try {
    oo_cm().consoleLog(i, v);
}
catch (e) { } return v; }
;
oo_oo;
function oo_tr(i, ...v) { try {
    oo_cm().consoleTrace(i, v);
}
catch (e) { } return v; }
;
oo_tr;
function oo_ts() { try {
    oo_cm().consoleTime();
}
catch (e) { } }
;
oo_ts;
function oo_te() { try {
    oo_cm().consoleTimeEnd();
}
catch (e) { } }
;
oo_te; /*eslint eslint-comments/disable-enable-pair:,eslint-comments/no-unlimited-disable:,eslint-comments/no-aggregating-enable:,eslint-comments/no-duplicate-disable:,eslint-comments/no-unused-disable:,eslint-comments/no-unused-enable:,*/


/***/ }),

/***/ "./src/components/context/app-provider/index.ts":
/*!******************************************************!*\
  !*** ./src/components/context/app-provider/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./app-provider.component */ "./src/components/context/app-provider/app-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/breakpoint-provider/breakpoint-provider.component.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/context/breakpoint-provider/breakpoint-provider.component.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BreakpointProvider = exports.findLast = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_debounce_1 = __webpack_require__(/*! use-debounce */ "use-debounce");
const resize_observer_polyfill_1 = tslib_1.__importDefault(__webpack_require__(/*! resize-observer-polyfill */ "resize-observer-polyfill"));
const useStyles = react_jss_1.createUseStyles({
    breakpoint: {
        margin: 0,
        padding: 0,
        border: 0,
        width: "100%",
        boxSizing: "border-box"
    }
});
function findLast(array, predicate) {
    let l = array.length;
    while (l--) {
        const o = array[l];
        if (predicate(o, l, array))
            return o;
    }
    return null;
}
exports.findLast = findLast;
const BreakpointProvider = (_a) => {
    var _b;
    var { children, className, as } = _a, props = tslib_1.__rest(_a, ["children", "className", "as"]);
    const ref = react_1.useRef(null);
    const styles = useStyles();
    const parentContextRef = smarthub_common_1.useHookRef(smarthub_common_1.useBreakpoint);
    const level = ((_b = parentContextRef.current) === null || _b === void 0 ? void 0 : _b.current) ? parentContextRef.current.current.level + 1
        : 0;
    const gridStyles = smarthub_common_1.useCreateGridStyles(`bp${level}`);
    const contextRef = react_1.useRef(null);
    const [context, setContextState] = react_1.useState(null);
    const [classNames, setClassNames] = react_1.useState(null);
    const RootElement = as || 'div';
    const setContext = react_1.useCallback((next) => {
        const { current: currentContext } = contextRef;
        const { current: current } = currentContext || {};
        const root = parentContextRef.root
            ? parentContextRef.root
            : current;
        contextRef.current = {
            current: Object.assign(Object.assign({}, current), next),
            root
        };
        setContextState(contextRef.current);
    }, []);
    const setBreakpoint = (width) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        var _c;
        const currentBp = findLast(smarthub_common_1.responsiveBreakPoints, bp => width >= bp.width);
        if (((_c = contextRef.current) === null || _c === void 0 ? void 0 : _c.current.size) != currentBp.size) {
            smarthub_common_1.responsiveBreakPoints.indexOf(currentBp);
            const classes = smarthub_common_1.responsiveBreakPoints
                .slice(0, currentBp.size + 1)
                .reduce((value, bp) => `${value} ${gridStyles[`bp${bp.name}`]}`, '');
            setClassNames(classes);
            setContext(Object.assign(Object.assign({}, currentBp), { level, styles: gridStyles }));
        }
    });
    const debounce = use_debounce_1.useDebouncedCallback(setBreakpoint, 300);
    react_1.useEffect(() => {
        const { current: currentContext } = contextRef;
        if (!currentContext)
            return;
        const { current: currentLevel } = currentContext;
        if (currentLevel.styles == gridStyles)
            return;
        const classes = smarthub_common_1.responsiveBreakPoints
            .slice(0, currentLevel.size + 1)
            .reduce((value, bp) => `${value} ${gridStyles[`bp${bp.name}`]}`, '');
        setClassNames(classes);
        setContext({
            styles: gridStyles
        });
    }, [gridStyles.grid]);
    react_1.useEffect(() => {
        if (level > 0) {
            const ro = new resize_observer_polyfill_1.default(entries => setBreakpoint(entries[0].contentRect.width));
            const { current } = ref;
            ro.observe(current);
            debounce(current.clientWidth);
            return () => {
                if (current)
                    ro.unobserve(current);
            };
        }
        const handleResize = () => setBreakpoint(window.innerWidth);
        window.addEventListener("resize", handleResize);
        debounce(window.innerWidth);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (RootElement == react_1.Fragment
        ? react_1.default.createElement(react_1.default.Fragment, null, context && react_1.default.createElement(smarthub_common_1.BreakpointContext.Provider, { value: context }, children))
        : react_1.default.createElement(RootElement, Object.assign({}, props, { ref: ref, className: [(className === null || className === void 0 ? void 0 : className.length) ? className : styles.breakpoint, classNames].join(' ') }), context && react_1.default.createElement(smarthub_common_1.BreakpointContext.Provider, { value: context }, children)));
};
exports.BreakpointProvider = BreakpointProvider;


/***/ }),

/***/ "./src/components/context/breakpoint-provider/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/context/breakpoint-provider/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./breakpoint-provider.component */ "./src/components/context/breakpoint-provider/breakpoint-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/chatbot-provider/chatbot-provider.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/context/chatbot-provider/chatbot-provider.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatBotProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_2 = __webpack_require__(/*! react */ "react");
const botframework_directlinejs_1 = __webpack_require__(/*! botframework-directlinejs */ "botframework-directlinejs");
const nextScope = (scopes, current, size) => {
    const first = scopes === null || scopes === void 0 ? void 0 : scopes[0];
    if (!current ||
        !(scopes === null || scopes === void 0 ? void 0 : scopes.length) ||
        (first.target === "panel" && size === "full"))
        return first;
    const scope = scopes.find(({ name, title, subTitle }) => current.name == name ||
        (current.title == title && current.subTitle == subTitle));
    return scope || first;
};
//TODO break out scope management
const ChatBotProvider = ({ children, webChatConfig, adaptiveCardHostConfig, }) => {
    const { cogsvc } = smarthub_common_1.useProviders();
    const authContext = smarthub_common_1.useAuth();
    const authContextRef = react_1.useRef(null);
    authContextRef.current = authContext;
    const profile = smarthub_common_1.useProfile();
    const profileRef = react_1.useRef(null);
    profileRef.current = profile;
    const theme = smarthub_common_1.useTheme();
    const { enabled: tpcEnabled } = smarthub_common_1.useTPCCheck();
    //TODO update state management of keywords - move to higher context
    const [, setKeywords] = smarthub_common_1.useKeywords();
    const sourceInfo = smarthub_common_1.useSourceInfo();
    const panelViewRef = smarthub_common_1.useHookRef(smarthub_common_1.usePanelView, "chat");
    const setPanelView = smarthub_common_1.useSetPanelView("chat");
    const setPanelState = react_1.useCallback((scope, selected = false) => {
        const { current: state } = panelViewRef;
        const isSearch = (scope === null || scope === void 0 ? void 0 : scope.target) === "panel";
        const visible = !isSearch ? selected : false;
        if (state.visible != visible) {
            setPanelView(Object.assign(Object.assign({}, state), { visible }));
        }
    }, []);
    //TODO update state management of scopes - move to child context
    const setScopes = react_1.useCallback((scopes, params) => {
        var _a;
        contextRef.current.scopes = scopes;
        const { current: { scope: currentScope }, } = contextRef;
        const scope = nextScope(scopes, currentScope, (_a = panelViewRef.current) === null || _a === void 0 ? void 0 : _a.size);
        if (currentScope != scope)
            setPanelState(scope);
        applyScope(scope, params);
        setContext({
            scopes,
            scope,
        });
    }, []);
    const applyScope = react_1.useCallback((chatContext, params) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { current: profile } = profileRef;
        try {
            if (chatContext === null || chatContext === void 0 ? void 0 : chatContext.scope) {
                const { current: { directlineContext: { config, directline }, }, } = contextRef;
                const scope = smarthub_common_1.deepReplaceParams(chatContext.scope, Object.assign(Object.assign({}, params), { profile }));
                yield smarthub_common_1.sendBackChannel(directline, config, profile, sourceInfo, {
                    payload: {
                        scope,
                    },
                    type: "context.scope",
                    version: "1.0",
                });
            }
            setKeywords(null);
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Failed to apply chat scope", false, ex);
        }
    }), []);
    const setScope = react_1.useCallback((scope, params) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        applyScope(scope, params);
        setPanelState(scope, true);
        setContext({
            scope,
        });
    }), []);
    const openDirectLine = react_1.useCallback((refresh) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { current: profile } = profileRef;
        const { current: auth } = authContextRef;
        try {
            let config;
            for (var i = 0; i < cogsvc.length; i++) {
                config = yield cogsvc[i].process(auth, config, refresh);
            }
            const { bot: { user: { id: userId, tokenOnly, ref: userToken }, token, personality, }, } = config;
            const directline = botframework_webchat_1.createDirectLine({
                token: token,
                watermark: "SmartChat",
                conversationStartProperties: {
                    locale: `[{"key":"personality","value":"${personality}"},{"key":"locale","value":"en-GB"}]`,
                },
            });
            if (!tokenOnly && directline.setUserId) {
                /*
                  HACK! when bot token does not contain a user attribute (v2)
                  the connection fails. Calling setUserId resolves the issue.
                  The WebChat still tries to set the userId which fails bc
                  directline has already connected.
                  Override the setUserId to fix this
                */
                directline.setUserId(userId);
                const setUserId = directline.setUserId;
                directline.setUserId = () => {
                    if (directline.connectionStatus$.getValue() !== botframework_directlinejs_1.ConnectionStatus.Online)
                        setUserId(userId);
                };
            }
            yield smarthub_common_1.sendBackChannel(directline, config, profile, sourceInfo, {
                payload: {
                    user: userToken,
                    personality,
                    tpc: tpcEnabled,
                },
                type: "context.user",
                version: "1.0",
            });
            setContext({
                directlineContext: {
                    directline,
                    config,
                },
            });
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Failed to load directline", false, ex);
        }
    }), []);
    const reset = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () { return openDirectLine(true); }), []);
    const contextRef = react_1.useRef({
        setScopes,
        setScope,
        reset,
    });
    const [context, setContextState] = react_2.useState(contextRef.current);
    const setContext = react_1.useCallback((next) => {
        contextRef.current = Object.assign(Object.assign({}, contextRef.current), next);
        setContextState(contextRef.current);
    }, []);
    react_2.useEffect(() => {
        const hostConfig = smarthub_common_1.mergeHostConfigStyles(adaptiveCardHostConfig, theme.definition);
        const styleOptions = smarthub_common_1.mergeWebchatStyles(webChatConfig.styleOptions, theme.definition);
        const styleSet = smarthub_common_1.mergeWebchatStyleset(webChatConfig.styleSet, styleOptions, theme.definition);
        setContext({
            hostConfig,
            webChat: Object.assign(Object.assign({}, webChatConfig), { styleOptions,
                styleSet }),
        });
    }, [theme]);
    react_2.useEffect(() => {
        if (authContext && profile && !(context === null || context === void 0 ? void 0 : context.directlineContext))
            openDirectLine();
    }, [authContext, profile]);
    return (react_1.default.createElement(smarthub_common_1.ChatBotContext.Provider, { value: context }, children));
};
exports.ChatBotProvider = ChatBotProvider;


/***/ }),

/***/ "./src/components/context/chatbot-provider/index.ts":
/*!**********************************************************!*\
  !*** ./src/components/context/chatbot-provider/index.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chatbot-provider.component */ "./src/components/context/chatbot-provider/chatbot-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/core-context/core-context.component.tsx":
/*!************************************************************************!*\
  !*** ./src/components/context/core-context/core-context.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CoreContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const __1 = __webpack_require__(/*! ../ */ "./src/components/context/index.ts");
const middleware_provider_1 = __webpack_require__(/*! ../middleware-provider */ "./src/components/context/middleware-provider/index.ts");
const CoreContext = (_a) => {
    var { children, middleware, localizeConfig, tpcCheck, themes, onAPIReady } = _a, props = tslib_1.__rest(_a, ["children", "middleware", "localizeConfig", "tpcCheck", "themes", "onAPIReady"]);
    return (react_1.default.createElement(__1.TPCCheckProvider, { config: tpcCheck },
        react_1.default.createElement(__1.BreakpointProvider, { as: react_1.Fragment },
            react_1.default.createElement(__1.AppProvider, Object.assign({}, props),
                react_1.default.createElement(__1.LocalizeProvider, { config: localizeConfig },
                    react_1.default.createElement(middleware_provider_1.MiddlewareProvider, { config: middleware },
                        react_1.default.createElement(__1.PreferenceProvider, null,
                            react_1.default.createElement(__1.ThemeProvider, { themes: themes },
                                react_1.default.createElement(__1.APIProvider, { onAPIReady: onAPIReady }, children)))))))));
};
exports.CoreContext = CoreContext;


/***/ }),

/***/ "./src/components/context/core-context/index.ts":
/*!******************************************************!*\
  !*** ./src/components/context/core-context/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./core-context.component */ "./src/components/context/core-context/core-context.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/extended-api/extended-api.component.tsx":
/*!************************************************************************!*\
  !*** ./src/components/context/extended-api/extended-api.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ExtendedAPI = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ExtendedAPI = ({ children }) => {
    const setExtendedAPI = smarthub_common_1.useSetExtendedAPI();
    const command = smarthub_common_1.useHandleCommand();
    const setBotReady = smarthub_common_1.useSetBotReady();
    react_1.useEffect(() => {
        setExtendedAPI({
            command
        });
        setBotReady(true);
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.ExtendedAPI = ExtendedAPI;


/***/ }),

/***/ "./src/components/context/extended-api/index.ts":
/*!******************************************************!*\
  !*** ./src/components/context/extended-api/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./extended-api.component */ "./src/components/context/extended-api/extended-api.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/extended-context/extended-context.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/context/extended-context/extended-context.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ExtendedContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const React = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const __1 = __webpack_require__(/*! ../ */ "./src/components/context/index.ts");
const chat_root_1 = __webpack_require__(/*! ../../chat-root */ "./src/components/chat-root/index.ts");
const ExtendedContext = ({ children, adaptiveCardHostConfig, webChatConfig }) => {
    return (React.createElement(__1.ProfileProvider, null,
        React.createElement(__1.NotificationProvider, null,
            React.createElement(__1.PanelsProvider, null,
                React.createElement(__1.LocationProvider, null,
                    React.createElement(__1.ChatBotProvider, Object.assign({}, {
                        webChatConfig,
                        adaptiveCardHostConfig
                    }),
                        React.createElement(chat_root_1.ChatRoot, null,
                            React.createElement(__1.ExtendedAPI, null, children))))))));
};
exports.ExtendedContext = ExtendedContext;


/***/ }),

/***/ "./src/components/context/extended-context/index.ts":
/*!**********************************************************!*\
  !*** ./src/components/context/extended-context/index.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./extended-context.component */ "./src/components/context/extended-context/extended-context.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/index.ts":
/*!*****************************************!*\
  !*** ./src/components/context/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./api-provider */ "./src/components/context/api-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./extended-api */ "./src/components/context/extended-api/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./extended-context */ "./src/components/context/extended-context/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-context */ "./src/components/context/core-context/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./app-provider */ "./src/components/context/app-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme-provider */ "./src/components/context/theme-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chatbot-provider */ "./src/components/context/chatbot-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./profile-provider */ "./src/components/context/profile-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panels-provider */ "./src/components/context/panels-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./localize-provider */ "./src/components/context/localize-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./middleware-provider */ "./src/components/context/middleware-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./breakpoint-provider */ "./src/components/context/breakpoint-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./location-provider */ "./src/components/context/location-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./notification-provider */ "./src/components/context/notification-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./preference-provider */ "./src/components/context/preference-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-view-provider */ "./src/components/context/panel-view-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-check-provider */ "./src/components/context/tpc-check-provider/index.ts"), exports);


/***/ }),

/***/ "./src/components/context/localize-provider/index.ts":
/*!***********************************************************!*\
  !*** ./src/components/context/localize-provider/index.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./localize-provider.component */ "./src/components/context/localize-provider/localize-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/localize-provider/localize-provider.component.tsx":
/*!**********************************************************************************!*\
  !*** ./src/components/context/localize-provider/localize-provider.component.tsx ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocalizeProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const LocalizeProvider = ({ children, config }) => {
    const setLocale = react_1.useCallback((lang) => {
        const localeConfig = config[lang];
        dayjs_1.default.locale(lang);
        if (localeConfig)
            setContext({
                config: localeConfig,
                locale: lang,
                setLocale
            });
    }, [config]);
    const [context, setContext] = react_1.useState(null);
    react_1.useEffect(() => {
        dayjs_1.default.locale(config.defaultLanguage);
        setContext({
            config: config[config.defaultLanguage],
            locale: config.defaultLanguage,
            setLocale
        });
    }, []);
    return react_1.default.createElement(smarthub_common_1.LocalizeContext.Provider, { value: context }, children);
};
exports.LocalizeProvider = LocalizeProvider;


/***/ }),

/***/ "./src/components/context/location-provider/index.ts":
/*!***********************************************************!*\
  !*** ./src/components/context/location-provider/index.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocationProvider = void 0;
var location_provider_component_1 = __webpack_require__(/*! ./location-provider.component */ "./src/components/context/location-provider/location-provider.component.tsx");
Object.defineProperty(exports, "LocationProvider", ({ enumerable: true, get: function () { return location_provider_component_1.LocationProvider; } }));


/***/ }),

/***/ "./src/components/context/location-provider/is-partial-location.helper.ts":
/*!********************************************************************************!*\
  !*** ./src/components/context/location-provider/is-partial-location.helper.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isPartialLocation = exports.isPartialItem = void 0;
const isPartialItem = (current, next) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!current)
        return true;
    const { panel: currentPanel, tab: currentTab } = current || {};
    const { panel, tab } = next || {};
    return (panel === null || panel === void 0 ? void 0 : panel.id) == ((_a = current === null || current === void 0 ? void 0 : current.panel) === null || _a === void 0 ? void 0 : _a.id)
        && ((!((_b = currentPanel === null || currentPanel === void 0 ? void 0 : currentPanel.entity) === null || _b === void 0 ? void 0 : _b.length) && ((_c = panel === null || panel === void 0 ? void 0 : panel.entity) === null || _c === void 0 ? void 0 : _c.length) > 0)
            || (!((_d = currentTab === null || currentTab === void 0 ? void 0 : currentTab.id) === null || _d === void 0 ? void 0 : _d.length) && ((_e = tab === null || tab === void 0 ? void 0 : tab.id) === null || _e === void 0 ? void 0 : _e.length) > 0)
            || (!((_f = currentTab === null || currentTab === void 0 ? void 0 : currentTab.entity) === null || _f === void 0 ? void 0 : _f.length) && ((_g = tab === null || tab === void 0 ? void 0 : tab.entity) === null || _g === void 0 ? void 0 : _g.length) > 0));
};
exports.isPartialItem = isPartialItem;
const isPartialLocation = (current, next) => !current
    || ((next === null || next === void 0 ? void 0 : next.main) && exports.isPartialItem(current === null || current === void 0 ? void 0 : current.main, next === null || next === void 0 ? void 0 : next.main))
    || ((next === null || next === void 0 ? void 0 : next.page) && exports.isPartialItem(current === null || current === void 0 ? void 0 : current.page, next === null || next === void 0 ? void 0 : next.page));
exports.isPartialLocation = isPartialLocation;


/***/ }),

/***/ "./src/components/context/location-provider/location-provider.component.tsx":
/*!**********************************************************************************!*\
  !*** ./src/components/context/location-provider/location-provider.component.tsx ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocationProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const is_partial_location_helper_1 = __webpack_require__(/*! ./is-partial-location.helper */ "./src/components/context/location-provider/is-partial-location.helper.ts");
const parse_location_helper_1 = __webpack_require__(/*! ./parse-location.helper */ "./src/components/context/location-provider/parse-location.helper.ts");
const stringify_location_helper_1 = __webpack_require__(/*! ./stringify-location.helper */ "./src/components/context/location-provider/stringify-location.helper.ts");
const use_app_location_hook_1 = __webpack_require__(/*! ./use-app-location.hook */ "./src/components/context/location-provider/use-app-location.hook.ts");
const use_debounce_1 = __webpack_require__(/*! use-debounce */ "use-debounce");
const use_handle_redirect_hook_1 = __webpack_require__(/*! ./use-handle-redirect.hook */ "./src/components/context/location-provider/use-handle-redirect.hook.ts");
const LocationProvider = ({ children }) => {
    const contextRef = react_1.useRef({
        location: null,
        path: ''
    });
    const handleRedirect = use_handle_redirect_hook_1.useHandleRedirect();
    const [next, setNext] = use_app_location_hook_1.useAppLocation();
    const [context, setContext] = react_1.useState(contextRef.current);
    const debounceNext = use_debounce_1.useDebouncedCallback((value) => {
        const { current: { location: current, path: currentPath } } = contextRef;
        const path = stringify_location_helper_1.stringifyLocation(value);
        if (currentPath == path)
            return;
        contextRef.current = {
            path,
            location: next
        };
        setContext(contextRef.current);
        const replace = is_partial_location_helper_1.isPartialLocation(current, value);
        if (replace)
            history.replaceState({}, "", path);
        else
            history.pushState({}, "", path);
    }, 50);
    react_1.useEffect(() => debounceNext(next), [next]);
    const onUrlChange = react_1.useCallback((url) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        let { path, location } = parse_location_helper_1.parseLocation(url);
        const redirected = yield handleRedirect(location);
        if (redirected) {
            const { current: { path: currentPath } = {} } = contextRef;
            history.replaceState({}, "", currentPath);
            return;
        }
        contextRef.current = {
            path,
            location
        };
        setContext(contextRef.current);
        setNext(location);
    }), []);
    react_1.useEffect(() => {
        const handleHashChange = ({ newURL }) => onUrlChange(newURL);
        window.addEventListener('hashchange', handleHashChange);
        onUrlChange(document.location.href);
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);
    return (react_1.default.createElement(smarthub_common_1.LocationContext.Provider, { value: context }, context && children));
};
exports.LocationProvider = LocationProvider;


/***/ }),

/***/ "./src/components/context/location-provider/parse-location.helper.ts":
/*!***************************************************************************!*\
  !*** ./src/components/context/location-provider/parse-location.helper.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseLocation = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const query_string_1 = tslib_1.__importDefault(__webpack_require__(/*! query-string */ "query-string"));
const parseId = (path, endPos, current) => {
    const colonPos = path.indexOf(":");
    if (~colonPos && colonPos < endPos) {
        current.id = path.substring(0, colonPos).trim();
        current.entity = decodeURIComponent(path.substring(colonPos + 1, endPos).trim());
    }
    else
        current.id = path.substring(0, endPos).trim();
};
const parseParams = (search) => {
    if (search.length <= 1)
        return {};
    const query = query_string_1.default.parse(search, { decode: true });
    return Object.keys(query).reduce((params, key) => {
        const keys = key.split('.');
        const value = query[key];
        let obj = params;
        keys.forEach((subKey, idx, keys) => {
            if (idx == keys.length - 1)
                obj[subKey] = value;
            else
                obj = obj[subKey] = (obj[subKey] || {});
        });
        return params;
    }, {});
};
const parsePath = (path, current) => {
    const nextSlash = path.indexOf('/');
    const nextHash = path.indexOf('#');
    let end = 0;
    if (~nextSlash && (!~nextHash || nextSlash < nextHash))
        parseId(path, end = nextSlash, current);
    else if (~nextHash && (!~nextSlash || nextHash < nextSlash)) {
        parseId(path, nextHash, current);
        current.params = parseParams(path.substring(nextHash + 1, end = ~nextSlash
            ? nextSlash
            : path.length));
    }
    else
        parseId(path, end = path.length, current);
    return path.substring(end + 1);
};
const parsePaths = (path, items) => {
    path = parsePath(path.indexOf('/') == 0
        ? path.substring(1)
        : path, items.panel);
    if (path.length)
        path = parsePath(path, items.tab);
    return path;
};
const parseLocation = (uri) => {
    const pos = uri.indexOf('#');
    const searchPos = uri.lastIndexOf('?');
    const hash = pos > 0
        ? uri.substring(pos + 1, searchPos > pos ? searchPos : undefined)
        : '';
    const search = searchPos > 0
        ? uri.substring(searchPos + 1, pos > searchPos ? pos : undefined)
        : '';
    const location = {
        main: {
            panel: { id: null },
            tab: { id: null }
        },
        page: null,
        params: parseParams(search)
    };
    if (hash.length) {
        const path = parsePaths(hash, location.main);
        if (path.length) {
            location.page = {
                panel: { id: null },
                tab: { id: null }
            };
            parsePaths(path, location.page);
        }
    }
    return {
        location,
        path: `${(hash === null || hash === void 0 ? void 0 : hash.length) ? '#' : ''}${hash}${(search === null || search === void 0 ? void 0 : search.length) ? '?' : ''}${search}`
    };
};
exports.parseLocation = parseLocation;


/***/ }),

/***/ "./src/components/context/location-provider/stringify-location.helper.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/context/location-provider/stringify-location.helper.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stringifyLocation = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const query_string_1 = tslib_1.__importDefault(__webpack_require__(/*! query-string */ "query-string"));
const flatten = (obj, flat, keyPath) => {
    const keys = Object.keys(obj);
    flat = flat !== null && flat !== void 0 ? flat : {};
    keyPath = keyPath !== null && keyPath !== void 0 ? keyPath : '';
    keys
        .sort()
        .forEach(key => {
        const value = obj[key];
        const flatKey = `${keyPath}${keyPath.length ? '.' : ''}${key}`;
        if (value && typeof value == 'object')
            flatten(value, flat, flatKey);
        else if (value && (typeof value != 'string' || value.length > 0))
            flat[flatKey] = value;
    });
    return flat;
};
const parseParams = (params, inline) => {
    if (!params || !Object.keys(params).length)
        return '';
    const flat = flatten(params);
    const serialised = query_string_1.default.stringify(flat, { encode: true });
    return serialised.length
        ? `${inline ? '#' : '?'}${serialised}`
        : '';
};
const parsePath = (item, separateEmpty) => {
    var _a;
    if (!((_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.length))
        return separateEmpty ? '/' : '';
    const { id, entity, params } = item;
    const prms = parseParams(params, true);
    const entId = (entity === null || entity === void 0 ? void 0 : entity.length) ? `:${encodeURIComponent(entity)}` : '';
    return `/${id}${entId}${prms}`;
};
const parsePaths = (items, separateEmpty) => {
    const panel = parsePath(items === null || items === void 0 ? void 0 : items.panel, separateEmpty);
    const tab = parsePath(items === null || items === void 0 ? void 0 : items.tab, separateEmpty);
    return `${panel}${tab}`;
};
const stringifyLocation = (appLocation) => {
    var _a, _b, _c;
    const main = parsePaths(appLocation.main, ((_c = (_b = (_a = appLocation.page) === null || _a === void 0 ? void 0 : _a.panel) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.length) > 0);
    const page = parsePaths(appLocation.page);
    const params = parseParams(appLocation.params);
    return `#${main}${page}${params}`;
};
exports.stringifyLocation = stringifyLocation;


/***/ }),

/***/ "./src/components/context/location-provider/use-app-location.hook.ts":
/*!***************************************************************************!*\
  !*** ./src/components/context/location-provider/use-app-location.hook.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAppLocation = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const use_location_items_hook_1 = __webpack_require__(/*! ./use-location-items.hook */ "./src/components/context/location-provider/use-location-items.hook.ts");
const useAppLocation = () => {
    const [main, setMain] = use_location_items_hook_1.useLocationItems('main');
    const [page, setPage] = use_location_items_hook_1.useLocationItems('page');
    const value = react_1.useMemo(() => ({ main, page }), [main, page]);
    const setter = react_1.useCallback((location) => {
        setMain(location === null || location === void 0 ? void 0 : location.main);
        setPage(location === null || location === void 0 ? void 0 : location.page);
    }, []);
    return [value, setter];
};
exports.useAppLocation = useAppLocation;


/***/ }),

/***/ "./src/components/context/location-provider/use-handle-redirect.hook.ts":
/*!******************************************************************************!*\
  !*** ./src/components/context/location-provider/use-handle-redirect.hook.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHandleRedirect = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const rgx = /^(?:http|https):\/\/(?:[a-z0-9-_.\/]*)/;
const parseAction = (param) => {
    if (typeof param == 'string')
        return {
            $id: '',
            $schema: smarthub_common_1.RouteActionSchema,
            uri: param
        };
    let { $schema } = param, rest = tslib_1.__rest(param, ["$schema"]);
    if (!$schema)
        $schema = smarthub_common_1.RouteActionSchema;
    else if (!rgx.test($schema))
        $schema = `${smarthub_common_1.ActionSchema}/${$schema}`;
    return Object.assign(Object.assign({}, rest), { $schema });
};
const useHandleRedirect = () => {
    const handleCommand = smarthub_common_1.useHandleCommand();
    return react_1.useCallback((next) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { page, $action } = (next === null || next === void 0 ? void 0 : next.params) || {};
        const action = $action
            ? parseAction($action)
            : page
                ? parseAction(page)
                : null;
        if (action) {
            yield handleCommand(action);
            return true;
        }
        return false;
    }), []);
};
exports.useHandleRedirect = useHandleRedirect;


/***/ }),

/***/ "./src/components/context/location-provider/use-location-item-params.hook.ts":
/*!***********************************************************************************!*\
  !*** ./src/components/context/location-provider/use-location-item-params.hook.ts ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocationItemParams = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const group = 'shared';
const channel = 'uri';
const useLocationItemParams = (source, level) => {
    var _a, _b, _c;
    const state = smarthub_common_1.useSharedStatePartition(group, channel, source, level);
    const params = react_1.useRef();
    params.current = (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.shared) === null || _a === void 0 ? void 0 : _a.uri) === null || _b === void 0 ? void 0 : _b[source]) === null || _c === void 0 ? void 0 : _c[level];
    const settter = recoil_1.useRecoilCallback(({ set }) => (nextParams) => {
        const currentRefs = Object.keys(params.current || {})
            .map(name => ({
            name,
            channel,
            group,
            level,
            source
        }));
        const nextRefs = Object.keys(nextParams || {})
            .map(name => ({
            name,
            channel,
            group,
            level,
            source,
            value: nextParams[name]
        }));
        const refs = [
            ...currentRefs,
            ...nextRefs
        ];
        refs.forEach(ref => set(smarthub_common_1.sharedStateSelector(smarthub_common_1.sharedStateId(ref)), ref.value));
    }, []);
    return [params.current, settter];
};
exports.useLocationItemParams = useLocationItemParams;


/***/ }),

/***/ "./src/components/context/location-provider/use-location-items.hook.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/context/location-provider/use-location-items.hook.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocationItems = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const use_panel_item_hook_1 = __webpack_require__(/*! ./use-panel-item.hook */ "./src/components/context/location-provider/use-panel-item.hook.ts");
const use_tab_item_hook_1 = __webpack_require__(/*! ./use-tab-item.hook */ "./src/components/context/location-provider/use-tab-item.hook.ts");
const useLocationItems = (type) => {
    const [panel, setPanel] = use_panel_item_hook_1.usePanelItem(type);
    const [tab, setTab] = use_tab_item_hook_1.useTabItem(type);
    const value = react_1.useMemo(() => ({ panel, tab }), [panel, tab]);
    const setter = react_1.useCallback((items) => {
        setPanel(items === null || items === void 0 ? void 0 : items.panel);
        setTab(items === null || items === void 0 ? void 0 : items.tab);
    }, []);
    return [value, setter];
};
exports.useLocationItems = useLocationItems;


/***/ }),

/***/ "./src/components/context/location-provider/use-panel-item.hook.ts":
/*!*************************************************************************!*\
  !*** ./src/components/context/location-provider/use-panel-item.hook.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePanelItem = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_location_item_params_hook_1 = __webpack_require__(/*! ./use-location-item-params.hook */ "./src/components/context/location-provider/use-location-item-params.hook.ts");
const level = 'panel';
const usePanelItem = (type) => {
    const [params, setParams] = use_location_item_params_hook_1.useLocationItemParams(type, level);
    const id = smarthub_common_1.usePanelId(type);
    const setId = smarthub_common_1.useSetPanelId(type);
    const entity = smarthub_common_1.usePanelEntityId(type);
    const value = react_1.useMemo(() => ({ id, entity, params }), [id, entity, params]);
    const setter = react_1.useCallback((item) => {
        setId(item === null || item === void 0 ? void 0 : item.id, item === null || item === void 0 ? void 0 : item.entity);
        setParams(item === null || item === void 0 ? void 0 : item.params);
    }, []);
    return [value, setter];
};
exports.usePanelItem = usePanelItem;


/***/ }),

/***/ "./src/components/context/location-provider/use-tab-item.hook.ts":
/*!***********************************************************************!*\
  !*** ./src/components/context/location-provider/use-tab-item.hook.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTabItem = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_location_item_params_hook_1 = __webpack_require__(/*! ./use-location-item-params.hook */ "./src/components/context/location-provider/use-location-item-params.hook.ts");
const level = 'tab';
const useTabItem = (type) => {
    const [params, setParams] = use_location_item_params_hook_1.useLocationItemParams(type, level);
    const id = smarthub_common_1.useTabId(type);
    const setId = smarthub_common_1.useSetTabId(type);
    const entity = smarthub_common_1.useTabEntityId(type);
    const value = react_1.useMemo(() => ({ id, entity, params }), [id, entity, params]);
    const setter = react_1.useCallback((item) => {
        setId(item === null || item === void 0 ? void 0 : item.id, item === null || item === void 0 ? void 0 : item.entity);
        setParams(item === null || item === void 0 ? void 0 : item.params);
    }, []);
    return [value, setter];
};
exports.useTabItem = useTabItem;


/***/ }),

/***/ "./src/components/context/middleware-provider/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/context/middleware-provider/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./middleware-provider.component */ "./src/components/context/middleware-provider/middleware-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/middleware-provider/middleware-provider.component.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/context/middleware-provider/middleware-provider.component.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MiddlewareProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const MiddlewareProvider = ({ children, config }) => {
    var _a;
    const { transforms: transformProvider } = (_a = smarthub_common_1.useProviders()) !== null && _a !== void 0 ? _a : {};
    const authContext = smarthub_common_1.useAuth();
    const [context, setContext] = react_1.useState(null);
    const loadMiddleware = () => {
        const ctx = Object.keys(config).reduce((context, k) => {
            context[k] = k != 'transform' ? config[k].middleware : null;
            return context;
        }, {});
        setContext(ctx);
    };
    const loadTransforms = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const templates = yield (transformProvider === null || transformProvider === void 0 ? void 0 : transformProvider.process(authContext));
            config.transform.collection.upsertTemplate(templates !== null && templates !== void 0 ? templates : []);
            setContext(Object.assign(Object.assign({}, context), { transform: config.transform.middleware }));
        }
        catch (ex) {
            smarthub_common_1.Logger.error(ex.message, false, { ex });
        }
    });
    react_1.useEffect(() => {
        if (!context)
            loadMiddleware();
        if (authContext && context && !(context === null || context === void 0 ? void 0 : context.transform) && transformProvider)
            loadTransforms();
    }, [authContext, context]);
    return react_1.default.createElement(smarthub_common_1.MiddlewareContext.Provider, { value: context }, context && children);
};
exports.MiddlewareProvider = MiddlewareProvider;


/***/ }),

/***/ "./src/components/context/notification-provider/index.ts":
/*!***************************************************************!*\
  !*** ./src/components/context/notification-provider/index.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./notification-provider.component */ "./src/components/context/notification-provider/notification-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/notification-provider/notification-provider.component.tsx":
/*!******************************************************************************************!*\
  !*** ./src/components/context/notification-provider/notification-provider.component.tsx ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NotificationProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const isSameOrBefore_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/isSameOrBefore */ "dayjs/plugin/isSameOrBefore"));
dayjs_1.default.extend(isSameOrBefore_1.default);
const key = 'dismissed-notifications';
const NotificationProvider = ({ children }) => {
    const { notifications: notificationProviders } = smarthub_common_1.useProviders();
    const fetch = smarthub_common_1.useFetch();
    const auth = smarthub_common_1.useAuth();
    const transform = smarthub_common_1.useTransform();
    const [context, setContext] = react_1.useState(null);
    const dismissedPrefRef = smarthub_common_1.useHookRef(smarthub_common_1.usePreference, key, true, []);
    const notificationsRef = react_2.useRef([]);
    const dismiss = react_1.useCallback(({ $id, source, expires }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const now = new Date();
        const [dismissedItems, setDismissedItems] = dismissedPrefRef.current;
        const items = dismissedItems.filter(d => dayjs_1.default(d.expires).isSameOrBefore(now)
            || (d.$id != $id && d.source != source));
        setDismissedItems([
            ...items,
            {
                $id,
                source,
                expires
            }
        ]);
        setNotifications(notificationsRef.current.filter(n => n.$id != $id && n.source != source));
    }), []);
    const dismissAll = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const now = new Date();
        const notifications = notificationsRef.current;
        const [dismissedItems, setDismissedItems] = dismissedPrefRef.current;
        const items = [
            ...dismissedItems.current.filter(d => dayjs_1.default(d.expires).isSameOrBefore(now)
                || !notifications.some(({ $id, source }) => d.$id != $id && d.source != source)),
            ...notifications.map(({ $id, source, expires }) => ({
                $id,
                source,
                expires
            }))
        ];
        setDismissedItems.current(items);
        setNotifications([]);
    }), []);
    const setNotifications = react_1.useCallback((notifications) => {
        notificationsRef.current = notifications;
        setContext({
            notifications,
            dismissAll,
            dismiss
        });
    }, []);
    react_1.useEffect(() => {
        let stop = false;
        setNotifications([]);
        const loadNotifications = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            try {
                notificationProviders === null || notificationProviders === void 0 ? void 0 : notificationProviders.forEach((provider) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                    var e_1, _a;
                    try {
                        for (var _b = tslib_1.__asyncValues(provider.listen(fetch, transform, auth)), _c; _c = yield _b.next(), !_c.done;) {
                            const list = _c.value;
                            if (stop)
                                return;
                            const notifications = notificationsRef.current;
                            const [dismissedItems] = dismissedPrefRef.current;
                            const items = list.filter(n => !dismissedItems.some(({ $id, source }) => n.$id == $id && n.source == source)
                                && !notifications.some(({ $id, source }) => n.$id == $id && n.source == source));
                            if (items.length > 0)
                                setNotifications([
                                    ...notifications,
                                    ...items
                                ]);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) yield _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }));
            }
            catch (ex) {
                smarthub_common_1.Logger.error(ex.message, false, { ex });
            }
        });
        if (auth && fetch && transform)
            loadNotifications();
        return () => {
            stop = true;
        };
    }, [auth, fetch, transform]);
    return react_1.default.createElement(smarthub_common_1.NotificationContext.Provider, { value: context }, children);
};
exports.NotificationProvider = NotificationProvider;


/***/ }),

/***/ "./src/components/context/panel-view-provider/entity-context.component.tsx":
/*!*********************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/entity-context.component.tsx ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EntityContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const template_context_component_1 = __webpack_require__(/*! ./template-context.component */ "./src/components/context/panel-view-provider/template-context.component.tsx");
const EntityContext = ({ panel, children }) => {
    const config = (panel === null || panel === void 0 ? void 0 : panel.entity) || {};
    const { query, title, description, props: { entitySchema = smarthub_common_1.IPanelEntitySchema, defaultEntity } = {} } = config;
    const entityId = smarthub_common_1.usePanelEntityId();
    const setEntityId = smarthub_common_1.useSetPanelEntityId();
    const entity = smarthub_common_1.usePanelEntity();
    const setEntity = smarthub_common_1.useSetPanelEntity();
    const fetch = smarthub_common_1.useFetch();
    const profile = smarthub_common_1.useProfile();
    const transform = smarthub_common_1.useTransform();
    react_1.useEffect(() => {
        var _a;
        const fetchEntity = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const { data } = yield fetch(query, { entityId });
            const entity = transform(entitySchema, data);
            setEntity(Object.assign(Object.assign({}, entity), { $entityId: entityId }));
        });
        if (!(panel === null || panel === void 0 ? void 0 : panel.entity)) {
            setEntity();
            return;
        }
        if (!(entityId === null || entityId === void 0 ? void 0 : entityId.length)) {
            if (defaultEntity && defaultEntity.source == 'profile' && ((_a = defaultEntity.property) === null || _a === void 0 ? void 0 : _a.length))
                setEntityId(profile[defaultEntity.property]);
            else if (entity)
                setEntityId(entity.$entityId);
            return;
        }
        if ((entity === null || entity === void 0 ? void 0 : entity.$entityId) == entityId)
            return;
        if (query)
            fetchEntity();
        else
            setEntity({
                $schema: smarthub_common_1.IPanelEntitySchema,
                $entityId: entityId,
                $id: entityId,
                uri: entityId.indexOf('http') == 0 ? entityId : null,
                type: null,
                title,
                description
            });
    }, [panel, entityId, entity, setEntity, setEntityId, config]);
    return react_1.default.createElement(template_context_component_1.TemplateContext, { panel: panel }, children);
};
exports.EntityContext = EntityContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/context/panel-view-provider/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-view-provider.component */ "./src/components/context/panel-view-provider/panel-view-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/panel-view-provider/panel-context.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/panel-context.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const entity_context_component_1 = __webpack_require__(/*! ./entity-context.component */ "./src/components/context/panel-view-provider/entity-context.component.tsx");
const template_context_component_1 = __webpack_require__(/*! ./template-context.component */ "./src/components/context/panel-view-provider/template-context.component.tsx");
const use_set_panel_data_hook_1 = __webpack_require__(/*! ./use-set-panel-data.hook */ "./src/components/context/panel-view-provider/use-set-panel-data.hook.ts");
const PanelContext = ({ children }) => {
    const panels = smarthub_common_1.usePanels();
    const panelId = smarthub_common_1.usePanelId();
    const panel = (panelId === null || panelId === void 0 ? void 0 : panelId.length) ? panels === null || panels === void 0 ? void 0 : panels.find(({ $id }) => $id == panelId) : null;
    const setData = use_set_panel_data_hook_1.useSetPanelData(panel, 'panel');
    const setInitialPanelId = smarthub_common_1.useSetInitialPanelId();
    react_1.useEffect(() => {
        setData();
    }, [setData]);
    react_1.useEffect(() => {
        if (!(panelId === null || panelId === void 0 ? void 0 : panelId.length))
            setInitialPanelId();
    }, [panels, panelId]);
    return (panel === null || panel === void 0 ? void 0 : panel.entity) ? react_1.default.createElement(entity_context_component_1.EntityContext, { panel: panel }, children)
        : react_1.default.createElement(template_context_component_1.TemplateContext, { panel: panel }, children);
};
exports.PanelContext = PanelContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/panel-view-provider.component.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/panel-view-provider.component.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelViewProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const panel_context_component_1 = __webpack_require__(/*! ./panel-context.component */ "./src/components/context/panel-view-provider/panel-context.component.tsx");
const PanelViewProvider = ({ type, children }) => {
    const config = smarthub_common_1.useViewConfig();
    const { visibility } = config[type];
    const { visible } = smarthub_common_1.usePanelView(type);
    const context = react_1.useMemo(() => ({
        type
    }), [type]);
    return react_1.useMemo(() => visible || visibility == 'auto'
        ? react_1.default.createElement(smarthub_common_1.CurrentPanelContext.Provider, { value: context },
            react_1.default.createElement(panel_context_component_1.PanelContext, null, children))
        : react_1.default.createElement(react_1.default.Fragment, null), [context, visible, visibility]);
};
exports.PanelViewProvider = PanelViewProvider;


/***/ }),

/***/ "./src/components/context/panel-view-provider/tab-context.component.tsx":
/*!******************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/tab-context.component.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TabContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_set_panel_data_hook_1 = __webpack_require__(/*! ./use-set-panel-data.hook */ "./src/components/context/panel-view-provider/use-set-panel-data.hook.ts");
const view_context_component_1 = __webpack_require__(/*! ./view-context.component */ "./src/components/context/panel-view-provider/view-context.component.tsx");
const TabContext = ({ panel, template, tabs, children }) => {
    const [tab, setTab] = react_1.useState();
    const setTabId = smarthub_common_1.useSetTabId();
    const tabId = smarthub_common_1.useTabId();
    const setData = use_set_panel_data_hook_1.useSetPanelData(tab, 'tab');
    smarthub_common_1.useAsyncEffect(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        setData();
    }), [setData]);
    smarthub_common_1.useAsyncEffect(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { items, preferred: { $id: preferredId } = {} } = tabs;
        const tab = (tabId === null || tabId === void 0 ? void 0 : tabId.length) ? items.find(({ $id }) => $id == tabId)
            : null;
        if (!tab)
            setTabId(preferredId);
        else
            setTab(tab);
    }), [tabId, tabs]);
    return tab
        ? react_1.default.createElement(view_context_component_1.ViewContext, { panel: panel, template: template, tabs: tabs.items, tab: tab }, children)
        : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.TabContext = TabContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/tabs-context.component.tsx":
/*!*******************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/tabs-context.component.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TabsContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tab_context_component_1 = __webpack_require__(/*! ./tab-context.component */ "./src/components/context/panel-view-provider/tab-context.component.tsx");
const TabsContext = ({ panel, template, children }) => {
    const allowed = smarthub_common_1.useConditions(`${template === null || template === void 0 ? void 0 : template.$id}-tabs`, template === null || template === void 0 ? void 0 : template.tabs, undefined, 'panel');
    const tabs = smarthub_common_1.useOrdered(allowed);
    return template && tabs.preferred
        ? react_1.default.createElement(tab_context_component_1.TabContext, { panel: panel, template: template, tabs: tabs }, children)
        : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.TabsContext = TabsContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/template-context.component.tsx":
/*!***********************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/template-context.component.tsx ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TemplateContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tabs_context_component_1 = __webpack_require__(/*! ./tabs-context.component */ "./src/components/context/panel-view-provider/tabs-context.component.tsx");
const use_set_panel_data_hook_1 = __webpack_require__(/*! ./use-set-panel-data.hook */ "./src/components/context/panel-view-provider/use-set-panel-data.hook.ts");
const TemplateContext = ({ panel, children }) => {
    const allowed = smarthub_common_1.useConditions(`${panel === null || panel === void 0 ? void 0 : panel.$id}-templates`, panel === null || panel === void 0 ? void 0 : panel.templates, undefined, 'panel');
    const ordered = smarthub_common_1.useOrdered(allowed);
    const template = panel && (allowed === null || allowed === void 0 ? void 0 : allowed.length)
        ? ordered.preferred
        : null;
    const setData = use_set_panel_data_hook_1.useSetPanelData(template, 'panel');
    react_1.useEffect(() => {
        setData();
    }, [setData]);
    return template
        ? react_1.default.createElement(tabs_context_component_1.TabsContext, { panel: panel, template: template }, children)
        : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.TemplateContext = TemplateContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/use-set-panel-data.hook.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/use-set-panel-data.hook.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetPanelData = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const channel = 'state';
const group = 'shared';
const useSetPanelData = (component, level) => {
    const { $id, dataSets } = component || {};
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const source = smarthub_common_1.usePanelType();
    const consumes = react_1.useMemo(() => dataSets === null || dataSets === void 0 ? void 0 : dataSets.reduce((all, { consumes }) => {
        return [
            ...all,
            ...(consumes || [])
        ];
    }, []), [dataSets]);
    const [sharedState, setSharedState] = smarthub_common_1.useSharedStates($id, undefined, level);
    const setSharedStates = smarthub_common_1.useSetSharedStates();
    react_1.useEffect(() => setSharedState(consumes), [consumes]);
    return react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (!(dataSets === null || dataSets === void 0 ? void 0 : dataSets.length))
            return Promise.resolve();
        const results = yield Promise.all(dataSets.map(({ name, query, schema }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const { data } = yield fetch(query, sharedState);
            const value = transform(schema, data);
            return { name, value };
        })));
        const dataItems = results.map(({ name, value }) => ({
            group,
            source,
            name,
            channel,
            level,
            value
        }));
        setSharedStates(dataItems);
    }), [sharedState, component]);
};
exports.useSetPanelData = useSetPanelData;


/***/ }),

/***/ "./src/components/context/panel-view-provider/view-context.component.tsx":
/*!*******************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/view-context.component.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ViewContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ViewContext = ({ panel, template, tab, tabs, children }) => {
    const globalScopes = smarthub_common_1.useGlobalChatScopes();
    const [context, setContext] = react_1.useState(null);
    const type = smarthub_common_1.usePanelType();
    const setScopes = smarthub_common_1.useSetChatScopes();
    const contextRef = react_1.useRef({
        type,
        panel,
        initialFocus: null,
        actions: null,
        regions: null,
        scopes: null,
        tab,
        tabs: tabs,
        template,
    });
    react_1.useEffect(() => {
        var _a;
        if (type == 'main' && ((_a = context === null || context === void 0 ? void 0 : context.scopes) === null || _a === void 0 ? void 0 : _a.length))
            setScopes(context.scopes);
    }, [context === null || context === void 0 ? void 0 : context.scopes]);
    react_1.useEffect(() => {
        if (!tab)
            return;
        const actions = [
            ...(panel.actions || []),
            ...(template.actions || []),
            ...(tab.actions || [])
        ];
        const scopes = [
            ...(tab.chatScopes || []),
            ...(template.chatScopes || []),
            ...(panel.chatScopes || []),
            ...(globalScopes || [])
        ];
        const regions = Object.assign(Object.assign(Object.assign({}, panel), template), tab);
        const { initialFocus } = regions;
        contextRef.current = Object.assign(Object.assign({}, contextRef.current), { type,
            panel,
            initialFocus,
            template,
            tabs,
            tab,
            regions,
            actions,
            scopes });
        setContext(contextRef.current);
    }, [tab]);
    react_1.useEffect(() => {
        const { current, current: { tabs: currentTabs } = {} } = contextRef;
        if (tabs == currentTabs)
            return;
        contextRef.current = Object.assign(Object.assign({}, current), { tabs });
        setContext(contextRef.current);
    }, [tabs]);
    react_1.useEffect(() => {
        const { current } = contextRef;
        contextRef.current = Object.assign(Object.assign({}, current), { panel });
        setContext(contextRef.current);
    }, [tabs]);
    return react_1.default.createElement(smarthub_common_1.PanelViewContext.Provider, { value: context }, context != null && children);
};
exports.ViewContext = ViewContext;


/***/ }),

/***/ "./src/components/context/panel-view-state-provider/index.ts":
/*!*******************************************************************!*\
  !*** ./src/components/context/panel-view-state-provider/index.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-view-state-provider.component */ "./src/components/context/panel-view-state-provider/panel-view-state-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/panel-view-state-provider/panel-view-state-provider.component.tsx":
/*!**************************************************************************************************!*\
  !*** ./src/components/context/panel-view-state-provider/panel-view-state-provider.component.tsx ***!
  \**************************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelViewStateProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
//TODO refactor
const PanelViewStateProvider = ({ children, type, }) => {
    var _a;
    const viewConfig = smarthub_common_1.useViewConfig();
    const view = viewConfig[type];
    const dockConfig = smarthub_common_1.useResponsiveProps(view === null || view === void 0 ? void 0 : view.dockSizes);
    const [size] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}DockSize`], false, dockConfig.preferred);
    const [position] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}DockPosition`], false, (_a = view === null || view === void 0 ? void 0 : view.dockPositions) === null || _a === void 0 ? void 0 : _a.preferred);
    const [launcher] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}LauncherState`], false, "closed");
    const [content] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}ContentView`], false, "normal");
    const setPanelView = smarthub_common_1.useSetPanelView(type);
    const panelViewRef = smarthub_common_1.useHookRef(smarthub_common_1.usePanelView, type);
    react_1.useEffect(() => {
        const { initialPanel: { visible } = {} } = view;
        if (!panelViewRef.current)
            setPanelView({
                size,
                position,
                visible,
                launcher,
                content,
            });
    }, []);
    react_1.useEffect(() => {
        let { current: state } = panelViewRef;
        if (!state)
            return;
        if (size != state.size && (size != "full" || state.size != "asside"))
            state = Object.assign(Object.assign({}, state), { size });
        if (position != state.position)
            state = Object.assign(Object.assign({}, state), { position });
        if (content != state.content)
            state = Object.assign(Object.assign({}, state), { content });
        if (state != panelViewRef.current) {
            panelViewRef.current = state;
            setPanelView(state);
        }
    }, [size, position, content]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.PanelViewStateProvider = PanelViewStateProvider;


/***/ }),

/***/ "./src/components/context/panels-provider/index.ts":
/*!*********************************************************!*\
  !*** ./src/components/context/panels-provider/index.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panels-provider.component */ "./src/components/context/panels-provider/panels-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/panels-provider/panels-provider.component.tsx":
/*!******************************************************************************!*\
  !*** ./src/components/context/panels-provider/panels-provider.component.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelsProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const panel_view_state_provider_1 = __webpack_require__(/*! ../panel-view-state-provider */ "./src/components/context/panel-view-state-provider/index.ts");
const PanelsProvider = ({ children }) => {
    const { panels: panelsProvider } = smarthub_common_1.useProviders();
    const authContext = smarthub_common_1.useAuth();
    const profile = smarthub_common_1.useProfile();
    const [context, setContext] = react_1.useState(null);
    const loadPanels = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const panels = yield panelsProvider.process(authContext, profile);
            setContext(panels);
        }
        catch (ex) {
            smarthub_common_1.Logger.error(ex.message, false, { ex });
        }
    });
    react_1.useEffect(() => {
        if (authContext && profile && !context)
            loadPanels();
    }, [authContext, profile]);
    return react_1.default.createElement(smarthub_common_1.PanelsContext.Provider, { value: context },
        react_1.default.createElement(panel_view_state_provider_1.PanelViewStateProvider, { type: "main" }),
        react_1.default.createElement(panel_view_state_provider_1.PanelViewStateProvider, { type: "page" }),
        react_1.default.createElement(panel_view_state_provider_1.PanelViewStateProvider, { type: "chat" }),
        children);
};
exports.PanelsProvider = PanelsProvider;


/***/ }),

/***/ "./src/components/context/preference-provider/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/context/preference-provider/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./preference-provider.component */ "./src/components/context/preference-provider/preference-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/preference-provider/preference-provider.component.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/context/preference-provider/preference-provider.component.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PreferenceProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const PreferenceProvider = ({ children }) => {
    const { preferences: providers } = smarthub_common_1.useProviders();
    const authContext = smarthub_common_1.useAuth();
    const authContextRef = react_1.useRef();
    authContextRef.current = authContext;
    const [preferences, setPreferences] = react_1.useState([]);
    const [context, setContext] = react_1.useState(null);
    const set = react_1.useCallback((key, value, cacheLevel = 'permanent') => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const { current: auth } = authContextRef;
            const provider = providers === null || providers === void 0 ? void 0 : providers[cacheLevel];
            if (value == null) {
                if (provider)
                    yield provider.remove(key, auth);
                setPreferences([
                    ...preferences.filter(p => p.key !== key)
                ]);
            }
            else {
                const preference = {
                    key,
                    value: typeof value == 'string'
                        ? value
                        : JSON.stringify(value)
                };
                if (provider)
                    yield provider.add(preference, auth);
                setPreferences([
                    ...preferences.filter(p => p.key !== key),
                    preference
                ]);
            }
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Could not set preference", true, ex);
        }
    }), [preferences]);
    const remove = react_1.useCallback((key, cacheLevel = 'permanent') => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const provider = providers === null || providers === void 0 ? void 0 : providers[cacheLevel];
            if (provider)
                yield provider.remove(key, authContextRef.current);
            setPreferences([
                ...preferences.filter(p => p.key !== key)
            ]);
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Could not remove preference", true, ex);
        }
    }), [preferences]);
    const get = react_1.useCallback((key, parse, defaultValue) => {
        var _a;
        try {
            const { value } = (_a = preferences.find(p => p.key == key)) !== null && _a !== void 0 ? _a : {};
            return (value === null || value === void 0 ? void 0 : value.length) ? parse
                ? JSON.parse(value)
                : value
                : defaultValue;
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Could not get preference", true, ex);
        }
    }, [preferences]);
    const loadPreferences = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const { current: auth } = authContextRef;
            const permanent = (providers === null || providers === void 0 ? void 0 : providers.permanent) && ((providers === null || providers === void 0 ? void 0 : providers.permanent.localStorage) || auth)
                ? yield providers.permanent.getAll(auth)
                : [];
            const temporary = (providers === null || providers === void 0 ? void 0 : providers.temporary) && (providers.temporary.localStorage
                || auth)
                ? yield providers.temporary.getAll(auth)
                : [];
            setPreferences([
                ...permanent,
                ...temporary
            ]);
        }
        catch (ex) {
            smarthub_common_1.Logger.error(ex.message, false, { ex });
        }
    });
    react_1.useEffect(() => {
        setContext({
            set,
            remove,
            get
        });
    }, [preferences]);
    react_1.useEffect(() => {
        loadPreferences();
    }, [authContext]);
    return react_1.default.createElement(smarthub_common_1.PreferenceContext.Provider, { value: context }, children);
};
exports.PreferenceProvider = PreferenceProvider;


/***/ }),

/***/ "./src/components/context/profile-provider/index.ts":
/*!**********************************************************!*\
  !*** ./src/components/context/profile-provider/index.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./profile-provider.component */ "./src/components/context/profile-provider/profile-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/profile-provider/profile-provider.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/context/profile-provider/profile-provider.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ProfileProvider = ({ children }) => {
    const { profile: profileProvider } = smarthub_common_1.useProviders();
    const profile = smarthub_common_1.useProfile();
    const setProfile = smarthub_common_1.useSetProfile();
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const authContext = smarthub_common_1.useAuth();
    const loadProfile = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const baseProfile = {
            $schema: smarthub_common_1.IPersonSchema,
            $id: null,
        };
        try {
            const profile = yield (profileProvider === null || profileProvider === void 0 ? void 0 : profileProvider.reduce((promise, provider) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                return (promise.then(profile => provider.process(fetch, transform, profile)));
            }), Promise.resolve(baseProfile)));
            setProfile(profile !== null && profile !== void 0 ? profile : baseProfile);
        }
        catch (ex) {
            smarthub_common_1.Logger.error(ex.message, false, { ex });
        }
    });
    react_1.useEffect(() => {
        if (authContext && fetch && transform && !profile)
            loadProfile();
    }, [authContext, fetch, transform]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.ProfileProvider = ProfileProvider;


/***/ }),

/***/ "./src/components/context/theme-provider/index.ts":
/*!********************************************************!*\
  !*** ./src/components/context/theme-provider/index.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./theme-provider.component */ "./src/components/context/theme-provider/theme-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/theme-provider/theme-provider.component.tsx":
/*!****************************************************************************!*\
  !*** ./src/components/context/theme-provider/theme-provider.component.tsx ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const ThemeProviderWrapper = react_1.forwardRef(({ children }, ref) => react_1.default.createElement(react_1.default.Fragment, null, children));
const ThemeProvider = ({ children, themes }) => {
    const [preferredThemeId] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.userTheme);
    const [selectedTheme, setSelectedTheme] = react_1.useState(null);
    const [context, setContext] = react_1.useState(null);
    const setTheme = react_1.useCallback((id) => {
        var _a;
        setSelectedTheme((_a = themes.find(t => t.$id == id)) !== null && _a !== void 0 ? _a : themes[0]);
    }, [themes]);
    react_1.useEffect(() => {
        var _a;
        const theme = selectedTheme != null
            ? selectedTheme
            : (preferredThemeId === null || preferredThemeId === void 0 ? void 0 : preferredThemeId.length) ? (_a = themes.find(({ $id }) => $id == preferredThemeId)) !== null && _a !== void 0 ? _a : themes[0] : themes[0];
        const fluentTheme = smarthub_common_1.mergeFluentTheme(theme.definition);
        setContext({
            setTheme,
            themes,
            theme,
            fluentTheme
        });
    }, [themes, preferredThemeId, selectedTheme]);
    return react_1.default.createElement(smarthub_common_1.ThemeContext.Provider, { value: context }, context && react_1.default.createElement(react_jss_1.ThemeProvider, { theme: context.theme.definition },
        react_1.default.createElement(react_2.ThemeProvider, { theme: context === null || context === void 0 ? void 0 : context.fluentTheme, as: ThemeProviderWrapper, applyTo: "none" }, children)));
};
exports.ThemeProvider = ThemeProvider;


/***/ }),

/***/ "./src/components/context/tpc-check-provider/index.ts":
/*!************************************************************!*\
  !*** ./src/components/context/tpc-check-provider/index.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-check-provider.component */ "./src/components/context/tpc-check-provider/tpc-check-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/tpc-check-provider/tpc-check-provider.component.tsx":
/*!************************************************************************************!*\
  !*** ./src/components/context/tpc-check-provider/tpc-check-provider.component.tsx ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TPCCheckProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const TPCCheckProvider = ({ children, config }) => {
    const { level, checkUri, infoUri } = config || { level: 'none' };
    const checkDisabled = !(checkUri === null || checkUri === void 0 ? void 0 : checkUri.length);
    const contextRef = react_1.useRef({
        checked: checkDisabled,
        level,
        enabled: checkDisabled,
        infoUri
    });
    const [context, setContext] = react_1.useState(contextRef.current);
    const callback = react_1.useCallback((e) => {
        var _a, _b;
        const enabled = (_b = (_a = e.data) === null || _a === void 0 ? void 0 : _a.smarthub) === null || _b === void 0 ? void 0 : _b.tpcCheck;
        if (enabled == undefined)
            return;
        const { current } = contextRef;
        setContext(Object.assign(Object.assign({}, current), {
            checked: true,
            enabled
        }));
    }, []);
    react_1.useEffect(() => {
        window.addEventListener('message', callback);
        return () => window.removeEventListener('message', callback);
    }, []);
    const allowUI = level !== 'error' || context.enabled;
    return react_1.default.createElement(react_1.default.Fragment, null,
        !context.checked && react_1.default.createElement("iframe", { src: `${checkUri}`, style: {
                width: '0px',
                height: '0px',
                border: '0px'
            } }),
        allowUI && react_1.default.createElement(smarthub_common_1.TPCCheckContext.Provider, { value: context }, children));
};
exports.TPCCheckProvider = TPCCheckProvider;


/***/ }),

/***/ "./src/components/focus-trap/focus-trap.component.tsx":
/*!************************************************************!*\
  !*** ./src/components/focus-trap/focus-trap.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FocusTrap = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const candidateSelectors = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    'not("[data-first]")',
    'not("[data-last]")',
    '[tabindex]:not([tabindex="-1"])',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    'details>summary:first-of-type',
    'details',
].join(',');
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { palette, spacing, fonts, sizes, styles } = theme;
    const panel = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.core) === null || _a === void 0 ? void 0 : _a.panel) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    const baseStyles = Object.assign(Object.assign({}, fonts.normal), { position: "absolute", height: `${sizes.normal}`, lineHeight: `${sizes.normal}`, padding: `0 ${spacing.smallPlus}`, textAlign: 'center', margin: 'auto', boxSizing: 'border-box', zIndex: 1, alignSelf: 'center', transition: "transform ease-out 300ms", backgroundColor: palette.primary, color: palette.primaryOn, transform: "scale(0)", "&:focus": {
            transform: "scale(1)"
        } });
    return {
        rootStyles: Object.assign({ position: 'relative' }, (smarthub_common_1.themeStyle(panel.root, props))),
        startStyles: Object.assign(Object.assign(Object.assign({}, baseStyles), { top: spacing.smallPlus }), (smarthub_common_1.themeStyle(panel.start, props))),
        endStyles: Object.assign(Object.assign(Object.assign({}, baseStyles), { bottom: spacing.smallPlus }), (smarthub_common_1.themeStyle(panel.start, props))),
    };
});
const FocusTrap = (_a) => {
    var { onClose, as, name, initialFocus, resetFocus, trapFocus, className, startLabel, endLabel, startText, endText, children } = _a, props = tslib_1.__rest(_a, ["onClose", "as", "name", "initialFocus", "resetFocus", "trapFocus", "className", "startLabel", "endLabel", "startText", "endText", "children"]);
    const { startStyles, endStyles, rootStyles } = useStyles();
    const register = smarthub_common_1.useRegisterFocus();
    const Tag = as || 'div';
    const start = react_1.useRef();
    const end = react_1.useRef();
    const ref = react_1.useRef(null);
    const focus = smarthub_common_1.useFocus();
    const onKeyDown = react_1.useCallback(({ key, target, shiftKey, stopPropagation, preventDefault }) => {
        if (key === "Escape") {
            onClose();
        }
        if (key !== 'Tab' || trapFocus === false)
            return;
        const { current: startEl } = start;
        const { current: endEl } = end;
        const nextEl = !shiftKey && target == endEl
            ? startEl
            : shiftKey && target == startEl
                ? endEl
                : null;
        if (nextEl) {
            nextEl.focus();
            stopPropagation();
            preventDefault();
        }
    }, []);
    react_1.useEffect(() => {
        var _a, _b, _c;
        if (initialFocus == 'first') {
            const el = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelector(candidateSelectors);
            if (el)
                el.focus();
        }
        else if (initialFocus == 'self')
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.focus();
        else if (initialFocus == 'start')
            (_c = start.current) === null || _c === void 0 ? void 0 : _c.focus();
        else if (initialFocus === null || initialFocus === void 0 ? void 0 : initialFocus.length)
            focus(initialFocus);
    }, [resetFocus]);
    react_1.useEffect(() => {
        if (name === null || name === void 0 ? void 0 : name.length)
            register(name, () => {
                ref.current && ref.current.focus();
            });
    }, []);
    return (react_1.default.createElement(Tag, Object.assign({}, props, { ref: ref, tabIndex: 0, className: [rootStyles, className].join(' ') }),
        react_1.default.createElement("div", { role: 'button', ref: start, onKeyDown: onKeyDown, "aria-label": startLabel, className: startStyles, tabIndex: 0 }, startText),
        children,
        react_1.default.createElement("div", { role: 'button', ref: end, onKeyDown: onKeyDown, "aria-label": endLabel, className: endStyles, tabIndex: 0 }, endText)));
};
exports.FocusTrap = FocusTrap;


/***/ }),

/***/ "./src/components/focus-trap/index.ts":
/*!********************************************!*\
  !*** ./src/components/focus-trap/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./focus-trap.component */ "./src/components/focus-trap/focus-trap.component.tsx"), exports);


/***/ }),

/***/ "./src/components/grid/column.component.tsx":
/*!**************************************************!*\
  !*** ./src/components/grid/column.component.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Column = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const React = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const component_wrapper_component_1 = __webpack_require__(/*! ./component-wrapper.component */ "./src/components/grid/component-wrapper.component.tsx");
const get_responsive_class_helper_1 = __webpack_require__(/*! ./get-responsive-class.helper */ "./src/components/grid/get-responsive-class.helper.ts");
const row_component_1 = __webpack_require__(/*! ./row.component */ "./src/components/grid/row.component.tsx");
const Column = ({ layout, column, contentView }) => {
    const styles = smarthub_common_1.useGridStyles();
    const { zones: layoutZones } = layout;
    const { tokens: { padding, hideOnExpand, spacer } = {}, responsive, zones } = column;
    const { col, padR, padL } = styles;
    const className = [col, padding == "normal" ? padR : "", (spacer == 'normal' ? padL : ''), get_responsive_class_helper_1.getResponsiveClass(styles, responsive)].join(" ");
    return (contentView != 'expanded' || !hideOnExpand)
        ? React.createElement("div", { className: className },
            column.zones && zones.map((zone, zoneIndex) => {
                const zoneConfig = layoutZones.find(c => c.id == zone.id);
                return (React.createElement(React.Fragment, { key: zoneIndex }, zoneConfig &&
                    zoneConfig.components.map((component) => React.createElement(component_wrapper_component_1.ComponentWrapper, { key: component.$id, config: component }))));
            }),
            column.rows && column.rows.map((row, rowIndex) => {
                return React.createElement(row_component_1.Row, { key: rowIndex, row: row, layout: layout, contentView: contentView });
            }))
        : null;
};
exports.Column = Column;


/***/ }),

/***/ "./src/components/grid/component-wrapper.component.tsx":
/*!*************************************************************!*\
  !*** ./src/components/grid/component-wrapper.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentWrapper = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ComponentWrapper = ({ config, data, fallback }) => {
    const render = smarthub_common_1.useRender();
    return render(config, data, fallback)();
};
exports.ComponentWrapper = ComponentWrapper;


/***/ }),

/***/ "./src/components/grid/get-responsive-class.helper.ts":
/*!************************************************************!*\
  !*** ./src/components/grid/get-responsive-class.helper.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getResponsiveClass = void 0;
const getResponsiveClass = (gridStyles, responsive) => {
    let className = [];
    if (responsive) {
        Object.keys(responsive).forEach(k => {
            let design = responsive[k];
            Object.keys(design).forEach(key => {
                const name = key == 'display' || key == 'size' || key == 'align' || key == 'wrap'
                    ? gridStyles[`${k}${design[key]}`]
                    : key == 'order' || key == 'max' || key == 'min'
                        ? gridStyles[`${k}${key}${design[key]}`]
                        : gridStyles[`${k}${key}`];
                className.push(name);
            });
        });
    }
    return className.join(" ");
};
exports.getResponsiveClass = getResponsiveClass;


/***/ }),

/***/ "./src/components/grid/grid.component.tsx":
/*!************************************************!*\
  !*** ./src/components/grid/grid.component.tsx ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Grid = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const get_responsive_class_helper_1 = __webpack_require__(/*! ./get-responsive-class.helper */ "./src/components/grid/get-responsive-class.helper.ts");
const row_component_1 = __webpack_require__(/*! ./row.component */ "./src/components/grid/row.component.tsx");
const Grid = ({ resetScroll, layout, as, className }) => {
    const styles = smarthub_common_1.useGridStyles();
    const { grid, padR, padB } = styles;
    const { content: contentView } = smarthub_common_1.usePanelView();
    const { grid: { tokens: { padding, spacer } = {}, responsive, rows } } = layout;
    const Tag = as || 'div';
    const combinedClass = [className, grid, padding == "none" ? "" : padR, (spacer == 'normal' ? padB : ''), get_responsive_class_helper_1.getResponsiveClass(styles, responsive)].join(" ");
    return (react_1.default.createElement(Tag, { className: combinedClass }, rows === null || rows === void 0 ? void 0 : rows.map((row, rowIndex) => react_1.default.createElement(row_component_1.Row, { key: `${rowIndex}-${resetScroll}`, row: row, layout: layout, contentView: contentView }))));
};
exports.Grid = Grid;


/***/ }),

/***/ "./src/components/grid/index.ts":
/*!**************************************!*\
  !*** ./src/components/grid/index.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./grid.component */ "./src/components/grid/grid.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./row.component */ "./src/components/grid/row.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./column.component */ "./src/components/grid/column.component.tsx"), exports);


/***/ }),

/***/ "./src/components/grid/row.component.tsx":
/*!***********************************************!*\
  !*** ./src/components/grid/row.component.tsx ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Row = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const React = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const column_component_1 = __webpack_require__(/*! ./column.component */ "./src/components/grid/column.component.tsx");
const get_responsive_class_helper_1 = __webpack_require__(/*! ./get-responsive-class.helper */ "./src/components/grid/get-responsive-class.helper.ts");
const Row = ({ layout, row, contentView }) => {
    const styles = smarthub_common_1.useGridStyles();
    const { tokens: { padding, hideOnExpand, spacer } = {}, responsive } = row;
    const { row: rowStyle, padT, padB } = styles;
    const className = [rowStyle, (padding == "normal" ? padT : ""), (spacer == 'normal' ? padB : ''), get_responsive_class_helper_1.getResponsiveClass(styles, responsive)].join(" ");
    return (contentView != 'expanded' || !hideOnExpand)
        ? React.createElement("div", { className: className }, row.columns && row.columns.map((col, colIndex) => React.createElement(column_component_1.Column, { key: colIndex, column: col, layout: layout, contentView: contentView })))
        : null;
};
exports.Row = Row;


/***/ }),

/***/ "./src/components/index.ts":
/*!*********************************!*\
  !*** ./src/components/index.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./app */ "./src/components/app/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-root */ "./src/components/chat-root/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chrome */ "./src/components/chrome/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./context */ "./src/components/context/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./focus-trap */ "./src/components/focus-trap/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./grid */ "./src/components/grid/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./launcher */ "./src/components/launcher/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./main-menu */ "./src/components/main-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel */ "./src/components/panel/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-chrome */ "./src/components/panel-chrome/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./region */ "./src/components/region/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./skip-links */ "./src/components/skip-links/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-message */ "./src/components/tpc-message/index.ts"), exports);


/***/ }),

/***/ "./src/components/launcher/index.ts":
/*!******************************************!*\
  !*** ./src/components/launcher/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./launcher.component */ "./src/components/launcher/launcher.component.tsx"), exports);


/***/ }),

/***/ "./src/components/launcher/launcher.component.tsx":
/*!********************************************************!*\
  !*** ./src/components/launcher/launcher.component.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Launcher = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tpc_message_1 = __webpack_require__(/*! ../tpc-message */ "./src/components/tpc-message/index.ts");
const launchButtonTemplateID = 'component.launch-button';
const splashTemplateID = 'component.splash-screen';
const Launcher = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    const [chromeState] = smarthub_common_1.useChromeState();
    const botReady = smarthub_common_1.useBotReady();
    const render = smarthub_common_1.useRender();
    return chromeState == 'closed'
        ? render(launchButtonTemplateID)()
        : react_1.default.createElement(tpc_message_1.TPCMessage, null,
            react_1.default.createElement(context_1.ExtendedContext, Object.assign({}, props),
                !botReady && render(splashTemplateID)(),
                children));
};
exports.Launcher = Launcher;


/***/ }),

/***/ "./src/components/main-menu/build-panel-links.helper.tsx":
/*!***************************************************************!*\
  !*** ./src/components/main-menu/build-panel-links.helper.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buildPanelLinks = void 0;
const buildPanelLinks = (panels, panelLinks, selectPanel, current) => panels.filter(({ navigation }) => navigation == 'primary' || navigation == 'secondary')
    .sort((a, b) => a.order - b.order)
    .reduce((panels, panel) => {
    const { $id, icon, shortTitle, title, description, navigation } = panel;
    const checked = current == $id;
    panels[navigation].push({
        key: $id,
        iconProps: {
            iconName: `${icon === null || icon === void 0 ? void 0 : icon.name}`
        },
        "aria-current": checked,
        checked,
        text: shortTitle,
        title: description,
        ariaLabel: title,
        ariaDescription: description,
        onClick: () => {
            selectPanel(panel);
        }
    });
    return panels;
}, panelLinks);
exports.buildPanelLinks = buildPanelLinks;


/***/ }),

/***/ "./src/components/main-menu/get-cache-key.helper.ts":
/*!**********************************************************!*\
  !*** ./src/components/main-menu/get-cache-key.helper.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getCacheKey = void 0;
const getCacheKey = ({ primaryItems, overflowItems, farItems }) => {
    const returnKey = (acc, { key }) => {
        return acc + key;
    };
    const primaryKey = (primaryItems === null || primaryItems === void 0 ? void 0 : primaryItems.length) && primaryItems.reduce(returnKey, '');
    const farKey = (farItems === null || farItems === void 0 ? void 0 : farItems.length) && farItems.reduce(returnKey, '');
    const overflowKey = (overflowItems === null || overflowItems === void 0 ? void 0 : overflowItems.length) ? 'overflow' : '';
    return [primaryKey, farKey, overflowKey].join('');
};
exports.getCacheKey = getCacheKey;


/***/ }),

/***/ "./src/components/main-menu/index.ts":
/*!*******************************************!*\
  !*** ./src/components/main-menu/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MainMenu = void 0;
var main_menu_component_1 = __webpack_require__(/*! ./main-menu.component */ "./src/components/main-menu/main-menu.component.tsx");
Object.defineProperty(exports, "MainMenu", ({ enumerable: true, get: function () { return main_menu_component_1.MainMenu; } }));


/***/ }),

/***/ "./src/components/main-menu/main-menu.component.tsx":
/*!**********************************************************!*\
  !*** ./src/components/main-menu/main-menu.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MainMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const menu_link_component_1 = __webpack_require__(/*! ./menu-link.component */ "./src/components/main-menu/menu-link.component.tsx");
const menu_more_button_component_1 = __webpack_require__(/*! ./menu-more-button.component */ "./src/components/main-menu/menu-more-button.component.tsx");
const use_menu_links_hook_1 = __webpack_require__(/*! ./use-menu-links.hook */ "./src/components/main-menu/use-menu-links.hook.tsx");
const get_cache_key_helper_1 = __webpack_require__(/*! ./get-cache-key.helper */ "./src/components/main-menu/get-cache-key.helper.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, sizes }) => ({
    resize: {
        height: '100vh',
        ["& > div > div:not([data-automation-id]) .ms-FocusZone"]: {
            height: "auto"
        }
    },
    focusZone: {
        display: "flex",
        flexDirection: "column",
        height: '100vh',
        justifyContent: "space-between"
    },
    menu: {
        zIndex: 1,
        transition: "margin-left 300ms ease-in-out",
        flex: "0 0",
        height: '100vh',
        minWidth: sizes.xxLarge,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        backgroundColor: palette.primaryNavBackground,
    },
    nav: {
        flex: "1 1",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
}));
const onReduceData = (data) => {
    let { primaryItems, overflowItems, farItems } = data;
    if (primaryItems.length > 0) {
        overflowItems = [...primaryItems.slice(-1), ...overflowItems];
        primaryItems = primaryItems.slice(0, -1);
    }
    else if (farItems.length > 0) {
        overflowItems = [...farItems.slice(-1), ...overflowItems];
        farItems = farItems.slice(0, -1);
    }
    else
        return undefined;
    const cacheKey = get_cache_key_helper_1.getCacheKey(data);
    return {
        primaryItems,
        overflowItems,
        farItems,
        cacheKey
    };
};
const onRenderOverflow = (data, styles, localize) => {
    const hasSecondSet = data.farItems && data.farItems.length > 0;
    return react_1.default.createElement(react_2.FocusZone, { direction: react_2.FocusZoneDirection.bidirectional, className: styles.focusZone },
        react_1.default.createElement(react_2.OverflowSet, { role: "menubar", "aria-label": localize.mainMenuPrimaryLabel, vertical: true, items: data.primaryItems, overflowItems: data.overflowItems.length ? data.overflowItems : null, onRenderItem: (item) => react_1.default.createElement(menu_link_component_1.MenuLink, Object.assign({}, item)), onRenderOverflowButton: (items) => react_1.default.createElement(menu_more_button_component_1.MenuMoreButton, { items: items }) }),
        hasSecondSet && react_1.default.createElement(react_2.OverflowSet, { role: "menubar", "aria-label": localize.mainMenuSecondaryLabel, vertical: true, items: data.farItems, onRenderItem: (item) => react_1.default.createElement(menu_link_component_1.MenuLink, Object.assign({}, item)), onRenderOverflowButton: () => { return null; } }));
};
const MainMenu = () => {
    const styles = useStyles();
    const localize = smarthub_common_1.useLocalizeConfig();
    const menuLinks = use_menu_links_hook_1.useMenuLinks();
    const { mode } = smarthub_common_1.useViewConfig();
    const hasLinks = ((menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.farItems.length) + (menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.overflowItems.length)
        + (menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.primaryItems.length)) > 0;
    return react_1.useMemo(() => (hasLinks && mode == 'full'
        ? react_1.default.createElement("nav", { className: styles.menu, title: localize.navTitle },
            react_1.default.createElement("section", { className: styles.nav },
                react_1.default.createElement(react_2.ResizeGroup, { className: styles.resize, role: "tabpanel", "aria-label": "Primary navigation", direction: react_2.ResizeGroupDirection.vertical, data: menuLinks, onReduceData: onReduceData, onRenderData: (data) => onRenderOverflow(data, styles, localize) })))
        : react_1.default.createElement(react_1.default.Fragment, null)), [menuLinks, styles, localize]);
};
exports.MainMenu = MainMenu;


/***/ }),

/***/ "./src/components/main-menu/menu-link.component.tsx":
/*!**********************************************************!*\
  !*** ./src/components/main-menu/menu-link.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuLink = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const fluentStyles = (({ theme: { palette, fonts, sizes, spacing } }) => ({
    root: {
        display: "block",
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        width: "100%",
        minWidth: 0,
        maxWidth: sizes.xxLarge,
        height: sizes.xLarge,
        border: `${spacing.tiny} solid transparent`,
        borderLeft: `${spacing.small} solid transparent`,
        backgroundColor: 'transparent',
        transitionTimingFunction: "ease-in",
        transitionDuration: "300ms",
        transitionProperty: "color, border-color, background-color",
    },
    rootHovered: {
        color: palette.filmOn,
        backgroundColor: palette.film,
    },
    rootPressed: {
        color: palette.filmOn,
        backgroundColor: palette.film,
    },
    rootFocused: {
        color: palette.filmOn,
        backgroundColor: palette.film,
        borderColor: palette.filmOn,
    },
    rootChecked: {
        color: palette.filmOn,
        backgroundColor: palette.film,
        borderLeftColor: palette.filmOn,
    },
    rootCheckedHovered: {
        color: palette.filmOn,
        backgroundColor: palette.film,
        borderColor: palette.filmOn,
    },
    rootCheckedPressed: {
        color: palette.filmOn,
        backgroundColor: palette.film,
        borderColor: palette.filmOn,
    },
    flexContainer: {
        width: "100%",
        flexDirection: "column",
        boxSizing: "border-box"
    },
    icon: Object.assign(Object.assign({}, fonts.xxLarge), { color: palette.primaryNavText, margin: `${spacing.medium} 0 0 -${spacing.small}`, width: "100%", height: sizes.small }),
    iconChecked: {
        color: palette.filmOn
    },
    label: Object.assign(Object.assign({}, fonts.tiny), { color: palette.primaryNavText, margin: `-${spacing.smallPlus} 0 0 -${spacing.smallPlus}`, height: sizes.smallPlus, lineHeight: sizes.smallPlus }),
    labelChecked: {
        color: palette.filmOn
    }
}));
const MenuLink = (_a) => {
    var { checked, data, onClick } = _a, rest = tslib_1.__rest(_a, ["checked", "data", "onClick"]);
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const registerLastFocus = smarthub_common_1.useRegisterLastAction();
    const buttonContent = react_1.useRef();
    const registerFocusCallback = react_1.useCallback(() => {
        registerLastFocus('main', () => {
            buttonContent.current.focus();
        });
    }, []);
    const handleClick = react_1.useCallback(() => {
        onClick(data);
        registerFocusCallback();
    }, [onClick, data]);
    return react_1.default.createElement(react_2.DefaultButton, Object.assign({ componentRef: buttonContent, checked: checked, styles: styles, onClick: handleClick }, rest));
};
exports.MenuLink = MenuLink;


/***/ }),

/***/ "./src/components/main-menu/menu-more-button.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/components/main-menu/menu-more-button.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuMoreButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const fluentStyles = (({ theme: { palette, fonts, sizes, spacing } }) => ({
    menu: {
        subComponentStyles: {
            callout: {},
            menuItem: ({ checked }) => ({
                label: {
                    fontWeight: checked && '600',
                    color: checked && palette.primary
                },
                icon: {
                    fontWeight: checked && '600',
                    color: checked && palette.primary
                }
            })
        }
    },
    more: {
        root: {
            display: "block",
            boxSizing: "border-box",
            margin: 0,
            padding: 0,
            width: "100%",
            minWidth: 0,
            maxWidth: sizes.xxLarge,
            height: sizes.xLarge,
            border: `${spacing.tiny} solid transparent`,
            borderLeft: `${spacing.small} solid transparent`,
            backgroundColor: 'transparent',
            transitionTimingFunction: "ease-in",
            transitionDuration: "300ms",
            transitionProperty: "color, border-color, background-color",
            "& .ms-Button-menuIcon": {
                color: palette.primaryNavText,
            }
        },
        rootHovered: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        rootFocused: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            borderColor: palette.filmOn,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        rootExpanded: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            borderColor: palette.filmOn,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        rootExpandedHovered: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            borderColor: palette.filmOn,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        rootPressed: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            borderColor: palette.filmOn,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        flexContainer: {
            width: "100%",
            flexDirection: "column-reverse",
            boxSizing: "border-box"
        },
        menuIcon: Object.assign(Object.assign({}, fonts.xxLarge), { color: palette.primaryNavText, order: 1, margin: `${spacing.medium} 0 0 ${spacing.small}`, width: "100%", height: fonts.xxLarge.fontSize }),
        menuIconHovered: {
            color: palette.filmOn,
        },
        menuIconPressed: {
            color: palette.filmOn,
        },
        menuIconExpanded: {
            color: palette.filmOn,
        },
        menuIconExpandedHovered: {
            color: palette.filmOn,
        },
        label: Object.assign(Object.assign({}, fonts.tiny), { order: 2, color: palette.primaryNavText, margin: `-${spacing.smallPlus} 0 0 -${spacing.smallPlus}`, height: sizes.smallPlus, lineHeight: sizes.smallPlus }),
    }
}));
const MenuMoreButton = ({ items }) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const localize = smarthub_common_1.useLocalizeConfig();
    return (react_1.default.createElement(react_2.CommandBarButton, { role: "menuitem", "aria-label": localize.panelMenuMoreLabel, title: localize.panelMenuMoreLabel, styles: styles.more, text: localize.panelMenuMoreText, menuIconProps: { iconName: 'More' }, menuProps: {
            styles: styles.menu,
            items: items
        } }));
};
exports.MenuMoreButton = MenuMoreButton;


/***/ }),

/***/ "./src/components/main-menu/use-action-links.hook.tsx":
/*!************************************************************!*\
  !*** ./src/components/main-menu/use-action-links.hook.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useActionLinks = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useActionLinks = () => {
    const actions = smarthub_common_1.useAppActions();
    const getThemeImage = smarthub_common_1.useGetThemeImageURI();
    const handleCommand = smarthub_common_1.useHandleCommand();
    return react_1.useMemo(() => actions
        .reduce((actions, appAction, idx) => {
        const { action, name, title, description, shortTitle, icon, position, coachmark } = appAction;
        actions[position !== null && position !== void 0 ? position : smarthub_common_1.AppActionPosition.farBefore].push({
            key: `${name}-${idx}`,
            text: shortTitle,
            iconProps: {
                iconName: typeof icon == 'string' ? icon : undefined,
                imageProps: icon && typeof icon == 'object'
                    ? {
                        src: getThemeImage(icon.image),
                        alt: typeof icon.image == 'object'
                            ? icon.image.text
                            : title
                    }
                    : undefined
            },
            ariaDescription: description,
            ariaLabel: title,
            title,
            coachmark: coachmark,
            onClick: () => handleCommand(action)
        });
        return actions;
    }, {
        [smarthub_common_1.AppActionPosition.farAfter]: [],
        [smarthub_common_1.AppActionPosition.farBefore]: [],
        [smarthub_common_1.AppActionPosition.moreAfter]: [],
        [smarthub_common_1.AppActionPosition.moreBefore]: [],
        [smarthub_common_1.AppActionPosition.nearAfter]: [],
        [smarthub_common_1.AppActionPosition.nearBefore]: [],
    }), [actions, getThemeImage]);
};
exports.useActionLinks = useActionLinks;


/***/ }),

/***/ "./src/components/main-menu/use-menu-links.hook.tsx":
/*!**********************************************************!*\
  !*** ./src/components/main-menu/use-menu-links.hook.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMenuLinks = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const use_action_links_hook_1 = __webpack_require__(/*! ./use-action-links.hook */ "./src/components/main-menu/use-action-links.hook.tsx");
const use_panel_links_hook_1 = __webpack_require__(/*! ./use-panel-links.hook */ "./src/components/main-menu/use-panel-links.hook.tsx");
const useMenuLinks = () => {
    const panelLinks = use_panel_links_hook_1.usePanelLinks();
    const actionLinks = use_action_links_hook_1.useActionLinks();
    return react_1.useMemo(() => {
        const data = {
            primaryItems: [
                ...actionLinks.nearBefore,
                ...panelLinks.primary,
                ...actionLinks.nearAfter,
            ],
            farItems: [
                ...actionLinks.farBefore,
                ...panelLinks.secondary,
                ...actionLinks.farAfter
            ],
            overflowItems: [
                ...actionLinks.moreBefore,
                ...actionLinks.moreAfter,
            ]
        };
        return data;
    }, [panelLinks, actionLinks]);
};
exports.useMenuLinks = useMenuLinks;


/***/ }),

/***/ "./src/components/main-menu/use-panel-links.hook.tsx":
/*!***********************************************************!*\
  !*** ./src/components/main-menu/use-panel-links.hook.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePanelLinks = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const build_panel_links_helper_1 = __webpack_require__(/*! ./build-panel-links.helper */ "./src/components/main-menu/build-panel-links.helper.tsx");
const usePanelLinks = () => {
    const panels = smarthub_common_1.usePanels();
    const setPanelId = smarthub_common_1.useSetPanelId();
    const current = smarthub_common_1.usePanelId();
    const setChatPanelView = smarthub_common_1.useSetPanelView();
    const chatPanelViewRef = smarthub_common_1.useHookRef(smarthub_common_1.usePanelView, 'chat');
    const pageViewRef = smarthub_common_1.useHookRef(smarthub_common_1.usePanelView, 'page');
    const setPage = smarthub_common_1.useSetPanelId('page');
    //TODO move to panelviewstate provider
    const selectPanel = react_1.useCallback((panel) => {
        if (chatPanelViewRef.current.visible && (chatPanelViewRef.current.size == 'full' || chatPanelViewRef.current.size == 'asside'))
            setChatPanelView(Object.assign(Object.assign({}, chatPanelViewRef.current), { visible: false }));
        if (pageViewRef.current.size == 'full')
            setPage();
        setPanelId(panel.$id);
    }, []);
    return react_1.useMemo(() => {
        const panelLinks = {
            primary: [],
            secondary: [],
        };
        return (panels === null || panels === void 0 ? void 0 : panels.length) ? build_panel_links_helper_1.buildPanelLinks(panels, panelLinks, selectPanel, current)
            : panelLinks;
    }, [panels, current]);
};
exports.usePanelLinks = usePanelLinks;


/***/ }),

/***/ "./src/components/panel-chrome/index.ts":
/*!**********************************************!*\
  !*** ./src/components/panel-chrome/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-chrome.component */ "./src/components/panel-chrome/panel-chrome.component.tsx"), exports);


/***/ }),

/***/ "./src/components/panel-chrome/panel-chrome.component.tsx":
/*!****************************************************************!*\
  !*** ./src/components/panel-chrome/panel-chrome.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelChrome = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const focus_trap_1 = __webpack_require__(/*! ../focus-trap */ "./src/components/focus-trap/index.ts");
const panel_inner_component_1 = __webpack_require__(/*! ./panel-inner.component */ "./src/components/panel-chrome/panel-inner.component.tsx");
const region_1 = __webpack_require__(/*! ../region */ "./src/components/region/index.ts");
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { palette, spacing, styles } = theme;
    const panel = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.panel) === null || _a === void 0 ? void 0 : _a.chrome) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        root: ({ config: { type }, }) => (Object.assign({ display: "flex", flexDirection: "column", justifyContent: "center", boxSizing: "border-box", transition: "top 200ms ease-in-out", height: "100vh", width: "100%", zIndex: 2, backgroundColor: type == "page"
                ? palette.neutralEmpty
                : type == "chat"
                    ? palette.neutralMinus3
                    : palette.neutralMinus5, color: type == "page"
                ? palette.neutralEmptyOn
                : type == "chat"
                    ? palette.neutralMinus3On
                    : palette.neutralMinus5On, boxShadow: `0 0 ${spacing.normal} ${palette.filmMinus1}`, "& *": {
                overscrollBehavior: "auto",
            }, "& *::-webkit-scrollbar-track": {
                borderRadius: spacing.xSmall,
                background: "transparent",
                border: "0",
            }, "& *::-webkit-scrollbar": {
                width: spacing.medium,
                height: spacing.medium,
                border: "0",
            }, "& *:hover::-webkit-scrollbar": {
                width: spacing.medium,
                height: spacing.medium,
            }, "& *::-webkit-scrollbar-thumb": {
                background: palette.primary,
                borderRadius: spacing.xSmall,
                border: "0",
            } }, smarthub_common_1.themeStyle(panel.root, props))),
        docked: ({ config: { size }, responsive, }) => (Object.assign({ transition: "width 200ms ease-in-out", width: smarthub_common_1.responsiveColumnWidths[responsive[size]] }, smarthub_common_1.themeStyle(panel.docked, { config: { size }, responsive, theme }))),
        full: ({ config: { size }, responsive, }) => (Object.assign(Object.assign({ left: 0, top: 0, right: 0, bottom: 0, display: "flex", position: responsive.overlay === false ? "relative" : "absolute", flex: responsive.overlay === false ? "1 1" : undefined }, smarthub_common_1.themeStyle(panel.full, { config: { size }, responsive, theme })), { ["& $inner"]: Object.assign({ width: responsive.overlay === false
                    ? "100%"
                    : smarthub_common_1.responsiveColumnWidths[responsive[size]] }, smarthub_common_1.themeStyle(panel.fullFrame, { config: { size }, responsive, theme })), ["& $overlay"]: Object.assign({ transition: "top 200ms ease-in-out", position: "absolute", left: 0, width: "100%", height: "100%", top: 0, backgroundColor: palette.neutralMinus5 }, smarthub_common_1.themeStyle(panel.fullOverlay, {
                config: { size },
                responsive,
                theme,
            })) })),
        overlay: Object.assign({}, smarthub_common_1.themeStyle(panel.overlay, props)),
        inner: Object.assign({ overflow: "hidden", display: "flex", flexDirection: "column", flex: "1 1", width: "100%", height: "100%", alignSelf: "center" }, smarthub_common_1.themeStyle(panel.inner, props)),
        "@supports (-webkit-touch-callout: none)": {
            root: ({ config: { type }, }) => ({
                height: "86vh",
            }),
        },
    };
});
const PanelChrome = () => {
    var _a, _b;
    const { panel, type, panel: { title, initialFocus }, regions, regions: { menu, launcher }, } = smarthub_common_1.usePanelViewContext();
    const entity = smarthub_common_1.usePanelEntity(type);
    const localise = smarthub_common_1.useLocalizeConfig();
    const endText = localise[`${type}EndText`];
    const startText = localise[`${type}StartText`];
    const endLabel = localise[`${type}EndLabel`];
    const startLabel = localise[`${type}StartLabel`];
    const panelLabel = localise[`${type}PanelLabel`];
    const viewConfig = smarthub_common_1.useViewConfig();
    const { dockSizes, trapFocus } = viewConfig[type];
    const viewState = smarthub_common_1.usePanelView();
    const gridStyles = smarthub_common_1.useGridStyles();
    const styleConfig = react_1.useMemo(() => (Object.assign(Object.assign({}, viewState), { type })), [viewState, type]);
    const styleProps = smarthub_common_1.useStyleProps(styleConfig, (_b = (_a = panel === null || panel === void 0 ? void 0 : panel.dock) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : dockSizes);
    const styles = useStyles(styleProps);
    const panelStyles = smarthub_common_1.usePanelStyles();
    const resetFocus = `${panel.$id}${entity === null || entity === void 0 ? void 0 : entity.$entityId}`;
    const resetPanelId = smarthub_common_1.useResetPanelId(type);
    const focusLastAction = smarthub_common_1.useFocusLastAction();
    const onClose = react_1.useCallback(() => {
        resetPanelId();
        focusLastAction(type);
    }, [type]);
    return react_1.useMemo(() => {
        var _a;
        return (react_1.default.createElement(focus_trap_1.FocusTrap, Object.assign({}, {
            as: "article",
            name: `${type}-panel`,
            endLabel,
            endText,
            startLabel,
            startText,
            trapFocus,
            initialFocus,
            resetFocus,
            onClose,
        }, { className: [
                styles.root,
                viewState.size == "full" ? styles.full : styles.docked,
            ].join(" "), "aria-label": `${panelLabel}, ${title}${((_a = entity === null || entity === void 0 ? void 0 : entity.title) === null || _a === void 0 ? void 0 : _a.length) ? `, ${entity.title}` : ""}` }),
            launcher && react_1.default.createElement(region_1.Region, { layout: launcher }),
            react_1.default.createElement("div", { className: styles.overlay }),
            menu && (react_1.default.createElement("nav", null,
                react_1.default.createElement(region_1.Region, { layout: menu }))),
            react_1.default.createElement(context_1.BreakpointProvider, { className: styles.inner },
                react_1.default.createElement(panel_inner_component_1.PanelInner, { regions: regions, resetScroll: resetFocus }))));
    }, [gridStyles, styles, panelStyles, regions, viewState, resetFocus, onClose]);
};
exports.PanelChrome = PanelChrome;


/***/ }),

/***/ "./src/components/panel-chrome/panel-inner.component.tsx":
/*!***************************************************************!*\
  !*** ./src/components/panel-chrome/panel-inner.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelInner = exports.useStyles = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const region_1 = __webpack_require__(/*! ../region */ "./src/components/region/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b, _c;
    const panel = (_c = (_b = (_a = theme.styles) === null || _a === void 0 ? void 0 : _a.panel) === null || _b === void 0 ? void 0 : _b.chrome) !== null && _c !== void 0 ? _c : {};
    const props = { theme };
    return {
        sidebar: ({ responsive: { overlay } }) => (Object.assign({ position: overlay ? "absolute" : "relative", height: "100%" }, smarthub_common_1.themeStyle(panel.sidebar, props))),
        header: smarthub_common_1.themeStyle(panel.header, props),
        bodyWrapper: {
            display: "flex",
            flex: "1",
            fontSize: "16px",
            overflow: "hidden",
            position: "relative",
            "& p": {
                fontSize: "16px",
                lineHeight: "1.5em",
                color: "inherit !important",
            },
            "& img": {
                display: "inherit !important",
            },
        },
        body: Object.assign({ flex: "1 1" }, smarthub_common_1.themeStyle(panel.body, props)),
        menu: Object.assign({ flex: "1 0 100%", width: "100%" }, smarthub_common_1.themeStyle(panel.menu, props)),
        footer: smarthub_common_1.themeStyle(panel.footer, props),
    };
});
const responsive = {
    sm: { overlay: true },
    lg: { overlay: false },
};
const PanelInner = ({ regions, resetScroll }) => {
    const { body, footer, header, sidebar, splash } = regions;
    const gridStyles = smarthub_common_1.useGridStyles();
    const styleProps = smarthub_common_1.useStyleProps(null, responsive);
    const styles = exports.useStyles(styleProps);
    const panelStyles = smarthub_common_1.usePanelStyles();
    return react_1.useMemo(() => (react_1.default.createElement("div", { className: [gridStyles.grid, gridStyles.row, gridStyles.smstretch].join(" ") },
        sidebar && (react_1.default.createElement("aside", { className: [
                gridStyles.col,
                gridStyles.smmax12,
                gridStyles.lgmax6,
                gridStyles.lgxmax4,
                gridStyles.xlmax3,
                gridStyles.xlxmax2,
                styles.sidebar,
            ].join(" ") },
            react_1.default.createElement(region_1.Region, { layout: sidebar }))),
        react_1.default.createElement("div", { className: [
                gridStyles.col,
                gridStyles.sm12,
                gridStyles.lg6,
                gridStyles.lgx8,
                gridStyles.xl9,
                gridStyles.xlx10,
                gridStyles.smclip,
                gridStyles.smfill,
                panelStyles.body,
            ].join(" ") },
            header && (react_1.default.createElement("header", null,
                react_1.default.createElement(region_1.Region, { layout: header }))),
            body && (react_1.default.createElement("div", { className: styles.bodyWrapper },
                splash && react_1.default.createElement(region_1.Region, { layout: splash }),
                react_1.default.createElement(region_1.Region, { as: "section", layout: body, className: styles.body, resetScroll: resetScroll }))),
            footer && (react_1.default.createElement("footer", null,
                react_1.default.createElement(region_1.Region, { layout: footer })))))), [
        gridStyles,
        styles,
        panelStyles,
        body,
        footer,
        header,
        sidebar,
        resetScroll,
    ]);
};
exports.PanelInner = PanelInner;


/***/ }),

/***/ "./src/components/panel/index.ts":
/*!***************************************!*\
  !*** ./src/components/panel/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel.component */ "./src/components/panel/panel.component.tsx"), exports);


/***/ }),

/***/ "./src/components/panel/panel.component.tsx":
/*!**************************************************!*\
  !*** ./src/components/panel/panel.component.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Panel = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const panel_chrome_1 = __webpack_require__(/*! ../panel-chrome */ "./src/components/panel-chrome/index.ts");
const Panel = ({ type }) => {
    return (react_1.default.createElement(context_1.PanelViewProvider, { type: type },
        react_1.default.createElement(panel_chrome_1.PanelChrome, null)));
};
exports.Panel = Panel;


/***/ }),

/***/ "./src/components/region/index.ts":
/*!****************************************!*\
  !*** ./src/components/region/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./region.component */ "./src/components/region/region.component.tsx"), exports);


/***/ }),

/***/ "./src/components/region/region.component.tsx":
/*!****************************************************!*\
  !*** ./src/components/region/region.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Region = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const grid_1 = __webpack_require__(/*! ../grid */ "./src/components/grid/index.ts");
const Region = (_a) => {
    var { layout, fallback, resetScroll } = _a, props = tslib_1.__rest(_a, ["layout", "fallback", "resetScroll"]);
    const render = smarthub_common_1.useRender();
    const isComponent = layout.hasOwnProperty('template')
        || layout.$schema == smarthub_common_1.IComponentSchema;
    return react_1.useMemo(() => isComponent
        ? render(layout, null, fallback)()
        : react_1.default.createElement(grid_1.Grid, Object.assign({ layout: layout, resetScroll: resetScroll }, props)), [layout, isComponent, fallback, resetScroll]);
};
exports.Region = Region;


/***/ }),

/***/ "./src/components/skip-links/index.ts":
/*!********************************************!*\
  !*** ./src/components/skip-links/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./skip-links.component */ "./src/components/skip-links/skip-links.component.tsx"), exports);


/***/ }),

/***/ "./src/components/skip-links/skip-links.component.tsx":
/*!************************************************************!*\
  !*** ./src/components/skip-links/skip-links.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SkipLinks = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles(({ sizes }) => ({
    root: {
        position: "absolute",
        top: `-${sizes.mediumPlus}`,
        height: `${sizes.mediumPlus}`,
        width: "100%",
        zIndex: 1,
        transition: "top ease-out 300ms",
        "&:focus-within": {
            top: 0
        }
    }
}));
const SkipLinks = () => {
    const styles = useStyles();
    const focus = smarthub_common_1.useFocus();
    const localize = smarthub_common_1.useLocalizeConfig();
    return react_1.useMemo(() => (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement(react_2.CommandBar, { items: [{
                    key: 'main-panel',
                    ariaLabel: localize.skipToMain,
                    title: localize.skipToMain,
                    text: localize.skipToMain,
                    onClick: () => { focus('main-panel'); }
                }, {
                    key: 'chat-controls',
                    ariaLabel: localize.skipToChat,
                    title: localize.skipToChat,
                    text: localize.skipToChat,
                    onClick: () => { focus('chat-controls'); }
                }] }))), []);
};
exports.SkipLinks = SkipLinks;


/***/ }),

/***/ "./src/components/tpc-message/index.ts":
/*!*********************************************!*\
  !*** ./src/components/tpc-message/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-message.component */ "./src/components/tpc-message/tpc-message.component.tsx"), exports);


/***/ }),

/***/ "./src/components/tpc-message/tpc-message.component.tsx":
/*!**************************************************************!*\
  !*** ./src/components/tpc-message/tpc-message.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TPCMessage = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const cacheKey = 'tpc';
const cacheOptions = {
    storage: 'session'
};
const modalProps = {
    isBlocking: false,
    styles: { main: { maxWidth: 550 } },
};
const TPCMessage = ({ children }) => {
    const { enabled, checked, level, infoUri } = smarthub_common_1.useTPCCheck();
    const allowUI = level == 'none'
        || (checked && level == 'info');
    const { mode } = smarthub_common_1.useViewConfig();
    const { tpcMessage: strings } = smarthub_common_1.useLocalizeConfig();
    const { okText, okTitle, okLabel, closeText, closeTitle, closeLabel, infoText, infoTitle, infoLabel, title, subText: subTextTypes } = strings[mode];
    const subText = subTextTypes[level];
    const [dismissed, setDismissed] = react_1.useState(true);
    react_1.useEffect(() => {
        const hasDismissed = level == 'none'
            || (checked && enabled)
            || (level == 'info'
                && smarthub_common_1.Cache.get(cacheKey, cacheOptions));
        setDismissed(hasDismissed);
    }, [enabled, checked]);
    const toggle = react_1.useCallback(() => {
        if (level == 'info')
            smarthub_common_1.Cache.set(cacheKey, true, cacheOptions);
        setDismissed(true);
    }, [level]);
    const dialogContentProps = {
        type: react_2.DialogType.largeHeader,
        title,
        subText
    };
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Dialog, { hidden: dismissed, onDismiss: toggle, dialogContentProps: dialogContentProps, modalProps: modalProps },
            react_1.default.createElement(react_2.DialogFooter, null,
                allowUI
                    ? react_1.default.createElement(react_2.PrimaryButton, { onClick: toggle, text: okText, title: okTitle, ariaLabel: okLabel })
                    : react_1.default.createElement(react_2.PrimaryButton, { onClick: toggle, title: closeTitle, text: closeText, ariaLabel: closeLabel }),
                (infoUri === null || infoUri === void 0 ? void 0 : infoUri.length) > 0 && react_1.default.createElement(react_2.DefaultButton, { text: infoText, title: infoTitle, href: infoUri, ariaLabel: infoLabel }))),
        allowUI && children);
};
exports.TPCMessage = TPCMessage;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./components */ "./src/components/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./middleware */ "./src/middleware/index.ts"), exports);


/***/ }),

/***/ "./src/middleware/bot/action-collection.middleware.ts":
/*!************************************************************!*\
  !*** ./src/middleware/bot/action-collection.middleware.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActionCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class ActionCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.cardAction.type == config.id;
    }
}
exports.ActionCollection = ActionCollection;


/***/ }),

/***/ "./src/middleware/bot/activity-collection.middleware.ts":
/*!**************************************************************!*\
  !*** ./src/middleware/bot/activity-collection.middleware.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActivityCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class ActivityCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.activity.type == config.id;
    }
}
exports.ActivityCollection = ActivityCollection;


/***/ }),

/***/ "./src/middleware/bot/attachment-collection.middleware.ts":
/*!****************************************************************!*\
  !*** ./src/middleware/bot/attachment-collection.middleware.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AttachmentCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class AttachmentCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.attachment.contentType == config.id;
    }
}
exports.AttachmentCollection = AttachmentCollection;


/***/ }),

/***/ "./src/middleware/bot/components/handle-any.fn.tsx":
/*!*********************************************************!*\
  !*** ./src/middleware/bot/components/handle-any.fn.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleAny = void 0;
const handleAny = ({ focus }, info) => {
    focus('chat-controls');
    return false;
};
exports.handleAny = handleAny;


/***/ }),

/***/ "./src/middleware/bot/components/handle-open-url.fn.tsx":
/*!**************************************************************!*\
  !*** ./src/middleware/bot/components/handle-open-url.fn.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleOpenUrl = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const handleOpenUrl = ({ handleCommand, focus }, { cardAction }) => {
    var _a, _b;
    const { value } = cardAction;
    const redirectorLink = value.match(/^https?:\/\/(?<domain>[a-zA-Z0-9\.\-]*)\/concierge\/linkredirector\.ashx\?FLEX_RESULT_URL=(?<url>[a-zA-Z0-9\.\-\%\_]*)&FLEX_RESULT_ID\=(?<id>[a-zA-Z0-9\-]*)$/);
    handleCommand({
        $id: "",
        $schema: smarthub_common_1.RouteActionSchema,
        uri: ((_a = redirectorLink === null || redirectorLink === void 0 ? void 0 : redirectorLink.groups) === null || _a === void 0 ? void 0 : _a.url) ? decodeURIComponent((_b = redirectorLink === null || redirectorLink === void 0 ? void 0 : redirectorLink.groups) === null || _b === void 0 ? void 0 : _b.url) : value
    });
    focus('chat-controls');
    return true;
};
exports.handleOpenUrl = handleOpenUrl;


/***/ }),

/***/ "./src/middleware/bot/components/handle-sign-in.fn.tsx":
/*!*************************************************************!*\
  !*** ./src/middleware/bot/components/handle-sign-in.fn.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleSignIn = void 0;
const attempts = [];
//TODO replace this with an action
const handleSignIn = ({ focus, localizeConfig }, { cardAction }) => {
    const { value } = cardAction;
    const repeat = attempts.indexOf(value) > -1;
    focus('chat-controls');
    if (!repeat)
        attempts.push(value);
    else
        alert(localizeConfig.chatSigningInMessage);
    return repeat;
};
exports.handleSignIn = handleSignIn;


/***/ }),

/***/ "./src/middleware/bot/components/index.ts":
/*!************************************************!*\
  !*** ./src/middleware/bot/components/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleAny = exports.handleSignIn = exports.handleOpenUrl = void 0;
var handle_open_url_fn_1 = __webpack_require__(/*! ./handle-open-url.fn */ "./src/middleware/bot/components/handle-open-url.fn.tsx");
Object.defineProperty(exports, "handleOpenUrl", ({ enumerable: true, get: function () { return handle_open_url_fn_1.handleOpenUrl; } }));
var handle_sign_in_fn_1 = __webpack_require__(/*! ./handle-sign-in.fn */ "./src/middleware/bot/components/handle-sign-in.fn.tsx");
Object.defineProperty(exports, "handleSignIn", ({ enumerable: true, get: function () { return handle_sign_in_fn_1.handleSignIn; } }));
var handle_any_fn_1 = __webpack_require__(/*! ./handle-any.fn */ "./src/middleware/bot/components/handle-any.fn.tsx");
Object.defineProperty(exports, "handleAny", ({ enumerable: true, get: function () { return handle_any_fn_1.handleAny; } }));


/***/ }),

/***/ "./src/middleware/bot/core-actionmiddleware.fn.ts":
/*!********************************************************!*\
  !*** ./src/middleware/bot/core-actionmiddleware.fn.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreActionMiddleware = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const components_1 = __webpack_require__(/*! ./components */ "./src/middleware/bot/components/index.ts");
const coreActionMiddleware = (props) => () => next => (actionInfo) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { cardAction: { type } } = actionInfo;
    const handled = type == 'openUrl'
        ? components_1.handleOpenUrl(props, actionInfo)
        : type == 'signin'
            ? components_1.handleSignIn(props, actionInfo)
            : components_1.handleAny(props, actionInfo);
    if (!handled)
        return next(actionInfo);
});
exports.coreActionMiddleware = coreActionMiddleware;


/***/ }),

/***/ "./src/middleware/bot/create-action-middleware.fn.ts":
/*!***********************************************************!*\
  !*** ./src/middleware/bot/create-action-middleware.fn.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createActionMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createActionMiddleware = (coreMiddleware, additionalMiddleware) => {
    return (props) => smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware(props));
};
exports.createActionMiddleware = createActionMiddleware;


/***/ }),

/***/ "./src/middleware/bot/create-activity-middleware.fn.ts":
/*!*************************************************************!*\
  !*** ./src/middleware/bot/create-activity-middleware.fn.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createActivityMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createActivityMiddleware = (coreMiddleware, additionalMiddleware) => {
    return (props) => smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware(props));
};
exports.createActivityMiddleware = createActivityMiddleware;


/***/ }),

/***/ "./src/middleware/bot/create-attachment-middleware.fn.ts":
/*!***************************************************************!*\
  !*** ./src/middleware/bot/create-attachment-middleware.fn.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createAttachmentMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createAttachmentMiddleware = (coreMiddleware, additionalMiddleware) => {
    return (props) => smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware(props));
};
exports.createAttachmentMiddleware = createAttachmentMiddleware;


/***/ }),

/***/ "./src/middleware/bot/index.ts":
/*!*************************************!*\
  !*** ./src/middleware/bot/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./components */ "./src/middleware/bot/components/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./action-collection.middleware */ "./src/middleware/bot/action-collection.middleware.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./activity-collection.middleware */ "./src/middleware/bot/activity-collection.middleware.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./attachment-collection.middleware */ "./src/middleware/bot/attachment-collection.middleware.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-actionmiddleware.fn */ "./src/middleware/bot/core-actionmiddleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./create-action-middleware.fn */ "./src/middleware/bot/create-action-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./create-activity-middleware.fn */ "./src/middleware/bot/create-activity-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./create-attachment-middleware.fn */ "./src/middleware/bot/create-attachment-middleware.fn.ts"), exports);


/***/ }),

/***/ "./src/middleware/fetch/components/fetch-concat.fn.ts":
/*!************************************************************!*\
  !*** ./src/middleware/fetch/components/fetch-concat.fn.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchConcat = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/middleware/fetch/helpers/index.ts");
const fetchConcat = (info) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { query } = info;
    const results = yield helpers_1.fetchGroupResults(query, info);
    return results.reduce((result, { id, data, continuation }) => {
        var _a;
        return ({
            id: query.id,
            data: [
                ...(_a = result === null || result === void 0 ? void 0 : result.data) !== null && _a !== void 0 ? _a : [],
                ...(data
                    ? Array.isArray(data)
                        ? data
                        : [data]
                    : [])
            ],
            continuation: (result === null || result === void 0 ? void 0 : result.continuation) || continuation
                ? Object.assign(Object.assign({}, result === null || result === void 0 ? void 0 : result.continuation), (continuation !== null && continuation !== void 0 ? continuation : { [id]: continuation })) : null
        });
    }, null);
});
exports.fetchConcat = fetchConcat;


/***/ }),

/***/ "./src/middleware/fetch/components/fetch-group.fn.ts":
/*!***********************************************************!*\
  !*** ./src/middleware/fetch/components/fetch-group.fn.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchGroup = exports.IGroupQuerySchema = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/middleware/fetch/helpers/index.ts");
exports.IGroupQuerySchema = "https://ics.ai/smarthub/query/group";
const fetchGroup = (info) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { query } = info;
    const results = yield helpers_1.fetchGroupResults(query, info);
    return results.reduce((result, { id, data, continuation }) => {
        var _a, _b;
        return ({
            id: query.id,
            data: Object.assign(Object.assign({ $schema: (_a = query.schema) !== null && _a !== void 0 ? _a : exports.IGroupQuerySchema, $id: query.id }, (_b = result === null || result === void 0 ? void 0 : result.data) !== null && _b !== void 0 ? _b : {}), (data ? { [id]: data } : {})),
            continuation: (result === null || result === void 0 ? void 0 : result.continuation) || continuation
                ? Object.assign(Object.assign({}, result === null || result === void 0 ? void 0 : result.continuation), (continuation !== null && continuation !== void 0 ? continuation : { [id]: continuation })) : null
        });
    }, null);
});
exports.fetchGroup = fetchGroup;


/***/ }),

/***/ "./src/middleware/fetch/components/fetch-items.fn.ts":
/*!***********************************************************!*\
  !*** ./src/middleware/fetch/components/fetch-items.fn.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchItems = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fetchItems = (info) => {
    var _a, _b;
    const { query, context, providers } = info;
    const provider = ((_a = query.provider) === null || _a === void 0 ? void 0 : _a.length) > 0
        ? providers.find(p => p.name == query.provider)
        : null;
    if (provider)
        return (context === null || context === void 0 ? void 0 : context.body) || ((_b = query.request) === null || _b === void 0 ? void 0 : _b.body)
            ? provider.submit(query, context)
            : provider.query(query, context);
    else
        smarthub_common_1.Logger.warn(`Provider ${query.provider} for query not found`, info);
    return Promise.reject();
};
exports.fetchItems = fetchItems;


/***/ }),

/***/ "./src/middleware/fetch/components/fetch-list.fn.ts":
/*!**********************************************************!*\
  !*** ./src/middleware/fetch/components/fetch-list.fn.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchList = exports.IListQuerySchema = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/middleware/fetch/helpers/index.ts");
exports.IListQuerySchema = "https://ics.ai/smarthub/query/list";
const fetchList = (info) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { query } = info;
    const results = yield helpers_1.fetchGroupResults(query, info);
    return results.reduce((result, { id, data, continuation }) => {
        var _a, _b;
        return ({
            id: query.id,
            data: [
                ...(_a = result === null || result === void 0 ? void 0 : result.data) !== null && _a !== void 0 ? _a : [],
                {
                    $schema: (_b = query.schema) !== null && _b !== void 0 ? _b : exports.IListQuerySchema,
                    $id: id,
                    data
                }
            ],
            continuation: (result === null || result === void 0 ? void 0 : result.continuation) || continuation
                ? Object.assign(Object.assign({}, result === null || result === void 0 ? void 0 : result.continuation), (continuation !== null && continuation !== void 0 ? continuation : { [id]: continuation })) : null
        });
    }, null);
});
exports.fetchList = fetchList;


/***/ }),

/***/ "./src/middleware/fetch/components/index.ts":
/*!**************************************************!*\
  !*** ./src/middleware/fetch/components/index.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-concat.fn */ "./src/middleware/fetch/components/fetch-concat.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-group.fn */ "./src/middleware/fetch/components/fetch-group.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-items.fn */ "./src/middleware/fetch/components/fetch-items.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-list.fn */ "./src/middleware/fetch/components/fetch-list.fn.ts"), exports);


/***/ }),

/***/ "./src/middleware/fetch/core-fetch-middleware.fn.ts":
/*!**********************************************************!*\
  !*** ./src/middleware/fetch/core-fetch-middleware.fn.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreFetchMiddleware = void 0;
const components_1 = __webpack_require__(/*! ./components */ "./src/middleware/fetch/components/index.ts");
const coreFetchMiddleware = () => next => (info) => {
    if (info.query.hasOwnProperty("queries")) {
        const { action } = info.query;
        switch (action) {
            case 'group': return components_1.fetchGroup(info);
            case 'list': return components_1.fetchList(info);
            default: return components_1.fetchConcat(info);
        }
    }
    else
        return components_1.fetchItems(info);
};
exports.coreFetchMiddleware = coreFetchMiddleware;


/***/ }),

/***/ "./src/middleware/fetch/create-fetch-middleware.fn.ts":
/*!************************************************************!*\
  !*** ./src/middleware/fetch/create-fetch-middleware.fn.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createFetchMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createFetchMiddleware = (coreMiddleware, additionalMiddleware) => {
    const middleware = smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware)({});
    //TODO redability
    return (...args) => {
        try {
            return middleware((obj) => {
                smarthub_common_1.Logger.error("[createMiddleware] fetch not found", false, { args: args, obj: obj });
                return obj;
            })(...args);
        }
        catch (err) {
            return JSON.stringify(err, null, 2);
        }
    };
};
exports.createFetchMiddleware = createFetchMiddleware;


/***/ }),

/***/ "./src/middleware/fetch/fetch-collection.middleware.ts":
/*!*************************************************************!*\
  !*** ./src/middleware/fetch/fetch-collection.middleware.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FetchCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class FetchCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.query.id == config.id;
    }
}
exports.FetchCollection = FetchCollection;


/***/ }),

/***/ "./src/middleware/fetch/helpers/fetch-group-results.helper.ts":
/*!********************************************************************!*\
  !*** ./src/middleware/fetch/helpers/fetch-group-results.helper.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchGroupResults = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const fetchGroupResults = (group, { context, providers, fetch }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const infos = group.queries.reduce((collection, query) => {
        const continuation = context.continuation
            ? context.continuation[query.id]
            : null;
        if (!context.continuation || continuation)
            collection.push({
                context: Object.assign(Object.assign({}, context), { continuation: continuation }),
                query,
                providers,
                fetch
            });
        return collection;
    }, []);
    return yield Promise.all(infos.map(info => fetch(info)));
});
exports.fetchGroupResults = fetchGroupResults;


/***/ }),

/***/ "./src/middleware/fetch/helpers/index.ts":
/*!***********************************************!*\
  !*** ./src/middleware/fetch/helpers/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-group-results.helper */ "./src/middleware/fetch/helpers/fetch-group-results.helper.ts"), exports);


/***/ }),

/***/ "./src/middleware/fetch/index.ts":
/*!***************************************!*\
  !*** ./src/middleware/fetch/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./components */ "./src/middleware/fetch/components/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./helpers */ "./src/middleware/fetch/helpers/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-fetch-middleware.fn */ "./src/middleware/fetch/core-fetch-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./create-fetch-middleware.fn */ "./src/middleware/fetch/create-fetch-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-collection.middleware */ "./src/middleware/fetch/fetch-collection.middleware.ts"), exports);


/***/ }),

/***/ "./src/middleware/index.ts":
/*!*********************************!*\
  !*** ./src/middleware/index.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./fetch */ "./src/middleware/fetch/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./render */ "./src/middleware/render/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./bot */ "./src/middleware/bot/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./transform */ "./src/middleware/transform/index.ts"), exports);


/***/ }),

/***/ "./src/middleware/render/create-render-middleware.fn.tsx":
/*!***************************************************************!*\
  !*** ./src/middleware/render/create-render-middleware.fn.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createRenderMiddleware = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createRenderMiddleware = (coreMiddleware, additionalMiddleware) => {
    const middleware = smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware)({});
    return (...args) => {
        try {
            return middleware(({ component, options, FallBack }) => (children) => {
                return FallBack
                    ? react_1.default.createElement(FallBack, { config: component, data: options }, children)
                    : react_1.default.createElement("div", null,
                        react_1.default.createElement("p", null, "No renderer for this component"),
                        react_1.default.createElement("pre", null, JSON.stringify({ component, options }, null, 2)));
            })(...args);
        }
        catch (err) {
            return () => (react_1.default.createElement("div", null,
                react_1.default.createElement("p", null, "Failed to render component"),
                react_1.default.createElement("pre", null, JSON.stringify(err, null, 2))));
        }
    };
};
exports.createRenderMiddleware = createRenderMiddleware;


/***/ }),

/***/ "./src/middleware/render/index.ts":
/*!****************************************!*\
  !*** ./src/middleware/render/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./create-render-middleware.fn */ "./src/middleware/render/create-render-middleware.fn.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./render-collection.middleware */ "./src/middleware/render/render-collection.middleware.ts"), exports);


/***/ }),

/***/ "./src/middleware/render/render-collection.middleware.ts":
/*!***************************************************************!*\
  !*** ./src/middleware/render/render-collection.middleware.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RenderCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class RenderCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.component.template == config.id;
    }
}
exports.RenderCollection = RenderCollection;


/***/ }),

/***/ "./src/middleware/transform/core-transform-middleware.fn.ts":
/*!******************************************************************!*\
  !*** ./src/middleware/transform/core-transform-middleware.fn.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreTransformMiddleware = void 0;
const coreTransformMiddleware = () => next => (info) => {
    return next(info);
};
exports.coreTransformMiddleware = coreTransformMiddleware;


/***/ }),

/***/ "./src/middleware/transform/create-transform-middleware.fn.ts":
/*!********************************************************************!*\
  !*** ./src/middleware/transform/create-transform-middleware.fn.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createTransformMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createTransformMiddleware = (coreMiddleware, additionalMiddleware) => {
    const middleware = smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware)({});
    //TODO redability
    return (...args) => {
        try {
            return middleware((obj) => {
                smarthub_common_1.Logger.error("[createMiddleware] transform not found", false, { args: args, obj: obj });
                return Array.isArray(obj === null || obj === void 0 ? void 0 : obj.data)
                    ? []
                    : null;
            })(...args);
        }
        catch (err) {
            return JSON.stringify(err, null, 2);
        }
    };
};
exports.createTransformMiddleware = createTransformMiddleware;


/***/ }),

/***/ "./src/middleware/transform/index.ts":
/*!*******************************************!*\
  !*** ./src/middleware/transform/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TransformCollection = exports.createTransformMiddleware = exports.coreTransformMiddleware = void 0;
var core_transform_middleware_fn_1 = __webpack_require__(/*! ./core-transform-middleware.fn */ "./src/middleware/transform/core-transform-middleware.fn.ts");
Object.defineProperty(exports, "coreTransformMiddleware", ({ enumerable: true, get: function () { return core_transform_middleware_fn_1.coreTransformMiddleware; } }));
var create_transform_middleware_fn_1 = __webpack_require__(/*! ./create-transform-middleware.fn */ "./src/middleware/transform/create-transform-middleware.fn.ts");
Object.defineProperty(exports, "createTransformMiddleware", ({ enumerable: true, get: function () { return create_transform_middleware_fn_1.createTransformMiddleware; } }));
var transform_collection_class_1 = __webpack_require__(/*! ./transform-collection.class */ "./src/middleware/transform/transform-collection.class.ts");
Object.defineProperty(exports, "TransformCollection", ({ enumerable: true, get: function () { return transform_collection_class_1.TransformCollection; } }));


/***/ }),

/***/ "./src/middleware/transform/transform-collection.class.ts":
/*!****************************************************************!*\
  !*** ./src/middleware/transform/transform-collection.class.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TransformCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class TransformCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    upsertTemplate(template) {
        if (template instanceof Array) {
            const handlers = template.map(t => this.createHandler(t));
            this.upsert(handlers);
            return;
        }
        const handler = this.createHandler(template);
        this.upsert(handler);
    }
    createHandler({ id, sourceSchema, targetSchema, template, priority }) {
        return {
            id,
            priority,
            sourceSchema,
            targetSchema,
            template: null,
            handle: function (info) {
                try {
                    return smarthub_common_1.transformData(template, info, this);
                }
                catch (ex) {
                    smarthub_common_1.Logger.error(`Failed to transform data ${ex}`, false, { info, template });
                }
            }
        };
    }
    testFallback(config, info) {
        var _a, _b, _c;
        if (Array.isArray(info.data))
            return ((_a = info.data) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = info.data[0]) === null || _b === void 0 ? void 0 : _b.$schema) == config.sourceSchema && info.targetSchema == config.targetSchema;
        else
            return ((_c = info.data) === null || _c === void 0 ? void 0 : _c.$schema) == config.sourceSchema && info.targetSchema == config.targetSchema;
    }
}
exports.TransformCollection = TransformCollection;


/***/ }),

/***/ "@fluentui/react":
/*!**********************************!*\
  !*** external "@fluentui/react" ***!
  \**********************************/
/***/ ((module) => {

module.exports = require("@fluentui/react");

/***/ }),

/***/ "botframework-directlinejs":
/*!********************************************!*\
  !*** external "botframework-directlinejs" ***!
  \********************************************/
/***/ ((module) => {

module.exports = require("botframework-directlinejs");

/***/ }),

/***/ "botframework-webchat":
/*!***************************************!*\
  !*** external "botframework-webchat" ***!
  \***************************************/
/***/ ((module) => {

module.exports = require("botframework-webchat");

/***/ }),

/***/ "dayjs":
/*!************************!*\
  !*** external "dayjs" ***!
  \************************/
/***/ ((module) => {

module.exports = require("dayjs");

/***/ }),

/***/ "dayjs/plugin/isSameOrBefore":
/*!**********************************************!*\
  !*** external "dayjs/plugin/isSameOrBefore" ***!
  \**********************************************/
/***/ ((module) => {

module.exports = require("dayjs/plugin/isSameOrBefore");

/***/ }),

/***/ "query-string":
/*!*******************************!*\
  !*** external "query-string" ***!
  \*******************************/
/***/ ((module) => {

module.exports = require("query-string");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/***/ ((module) => {

module.exports = require("react");

/***/ }),

/***/ "react-jss":
/*!****************************!*\
  !*** external "react-jss" ***!
  \****************************/
/***/ ((module) => {

module.exports = require("react-jss");

/***/ }),

/***/ "recoil":
/*!*************************!*\
  !*** external "recoil" ***!
  \*************************/
/***/ ((module) => {

module.exports = require("recoil");

/***/ }),

/***/ "resize-observer-polyfill":
/*!*******************************************!*\
  !*** external "resize-observer-polyfill" ***!
  \*******************************************/
/***/ ((module) => {

module.exports = require("resize-observer-polyfill");

/***/ }),

/***/ "smarthub-common":
/*!**********************************!*\
  !*** external "smarthub-common" ***!
  \**********************************/
/***/ ((module) => {

module.exports = require("smarthub-common");

/***/ }),

/***/ "tslib":
/*!************************!*\
  !*** external "tslib" ***!
  \************************/
/***/ ((module) => {

module.exports = require("tslib");

/***/ }),

/***/ "use-debounce":
/*!*******************************!*\
  !*** external "use-debounce" ***!
  \*******************************/
/***/ ((module) => {

module.exports = require("use-debounce");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.ts");
/******/ 	var __webpack_export_target__ = exports;
/******/ 	for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
/******/ 	if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.js.map